import { makeAutoObservable, runInAction, toJS } from "mobx";
import { apiLink } from "../helpers/constantVariables";
import {
  getInterviewApplicants,
  updateInterview,
  deleteInterview as deleteInterviewApi,
  getMockTestApplicants,
  getInterview,
  updateMockTest,
  deleteMockTest as deleteMockTestApi,
} from "../api/recruiterAssessmentsApi";
import {
  apiDelete,
  apiGet,
  apiPostPut,
  apiPostPutPublic,
} from "../api/api_methods";
import { getAllTeamMembers } from "../api/recruiterUsersApi";
import {
  listJobPosts,
  getJobPost,
  createJobPost,
  updateJobPost as updateJobPostApi,
  deleteJobPost,
  postJobAiChat,
  getRecruiterJds,
} from "../api/recruiterJobsApi";
import {
  getRecruiterInvitations,
  getCompanyInterviewInvitations,
  getMockTestInvitations,
} from "../api/recruiterInvitationsApi";
import {
  getJobApplications,
  getApplicationDetail,
  updateApplicationDetail,
  getApplicationTracking,
  changeApplicationStatus,
  generateApplicantEvaluation,
} from "../api/recruiterApplicationsApi";
import {
  createVerification as createVerificationApi,
  getVerificationByApplicationAndUser as getVerificationByAppAndUserApi,
  addVerificationType as addVerificationTypeApi,
  updateVerificationStatus as updateVerificationStatusApi,
  updateVerification as updateVerificationApi,
  addProofDocuments as addProofDocumentsApi,
  addGlobalNote as addGlobalNoteApi,
  getVerificationSummary as getVerificationSummaryApi,
} from "../api/recruiterVerificationApi";
import { getResumeScoresByJd } from "../api/recruiterResumeScoresApi";
import Technical from "../components/recruiter/technical";
import CommonStore from "./common_store";
import { name } from "../services/white_label";
import Dashboard from "../components/dashboard/dashboard";
// import user from "../store/user";

const DASHBOARD_BASE = "/v1/recruiter/dashboard";

class RecuiterStore {
  commonStore;

  constructor(rootStore) {
    this.rootStore = rootStore;
    this.userStore = rootStore?.UserStore;
    this.commonStore = new CommonStore();
    makeAutoObservable(this);
  }

  getCurrentUser() {
    return this.userStore?.userDetails || null;
  }

  getCurrentUserId() {
    let localId = null;
    try {
      const userStr = localStorage.getItem("user");
      if (userStr) {
        const parsed = JSON.parse(userStr);
        if (
          parsed &&
          typeof parsed === "object" &&
          typeof parsed._id === "string"
        ) {
          localId = parsed._id;
        }
      }
    } catch (e) {
      console.error("Error parsing user from localStorage", e);
    }
    return this.userStore?.userDetails?._id || localId || null;
  }

  getTeamOwnerOrUserId() {
    const user = this.userStore?.userDetails;
    if (!user) return null;
    return user.teamOwner || user._id || null;
  }
  latestActivity = {};
  closeActivity = false;
  latestActivityVisible = false;
  completionStatus = "";
  interviewType = "";
  appliedFor = "";
  appliedDate = "";
  score = "";
  filter = false;
  status = "";
  applicantSearch = "";
  isRunningAutoPost = false;
  jobPosts = [];
  jobPostId = null;
  jobpostcount = 0;
  jobListPage = 0;
  applicationCount = 0;
  recuirterjobpostcount = 0;
  recuirterjobpostskip = 0;
  recuirterjobpostlimit = 10;
  clientId = "";
  searchInitiated = false;

  recuirterinverviewcount = 0;
  recuirterinverviewskip = 0;
  recuirterinverviewlimit = 10;

  recuirterjobapplicantscount = 0;
  recuirterjobapplicantskip = 0;
  recuirterjobapplicantlimit = 10;
  applicantskip = 0;
  applicantcount = 0;
  applicantlimit = 10;
  InterviewApplicants = [];
  jobapplicants = {};
  clients = [];
  job = {};
  generaterLoader = false;
  jdId = "";
  jd = [];
  mockTest = [];
  mcqcount = 0;
  resumeCount = 0;
  mcqskip = 0;
  mcqlimit = 10;
  resumeScore = {
    data: {
      resumes: [],
      isSortingCompleted: false,
      isExtractionCompleted: false,
    },
    count: 0,
  };
  resumeScoreDataCount = 0;
  allInvitations = {};
  Techincalcount = null;
  skillsField = false;
  jobPostEditable = 0;
  selectedInterviewsCount = 1;
  selectedJobPostsCount = 1;
  selectedMcqCount = 1;
  selectedResumeAnalyzerCount = 1;
  mailType = "";
  mailTemplate = "";
  remainderMails = [];
  receiptentMails = [];
  applicantProgres = [];
  tractionData = {};
  refreshObject = {
    dashboard: 0,
    history: 0,
    talentPool: 0,
    tags: 0,
    settings: 0,
  };
  categories = {
    completed: [],
    incomplete: [],
    notStarted: [],
    shortlisted: [],
    rejected: [],
    hired: [],
    pending: [],
  };
  remainderMailType = "";
  Teams = [];
  previousPageForTalentPool = 0;
  interviewPrice = 179;
  resumeScreeningPrice = 9;
  jobPostingsPrice = 0;
  mcqPrice = 0;
  paymentTotal = 0;
  setApplicantProgres(val) {
    this.applicantProgres = val;
  }
  setPaymentTotal(val) {
    this.paymentTotal = val;
  }

  setSelectedInterviewsCount(val) {
    this.selectedInterviewsCount = val;
  }
  setSelectedJobPostsCount(val) {
    this.selectedJobPostsCount = val;
  }
  setSelectedMcqCount(val) {
    this.selectedMcqCount = val;
  }
  setSelectedResumeAnalyzerCount(val) {
    this.selectedResumeAnalyzerCount = val;
  }
  setPreviousPageForTalentPool(val) {
    this.previousPageForTalentPool = val;
  }
  setInvitations(val) {
    this.allInvitations = val;
  }
  setTeams(val) {
    this.Teams = val;
  }
  setIsRunningAutoPost(val) {
    this.isRunningAutoPost = val;
  }

  setTractionData(val) {
    this.tractionData = val;
  }
  setRemainderMailType(val) {
    this.remainderMailType = val;
  }
  setCategories(val) {
    this.categories = val;
  }
  setReceiptentMails(val) {
    this.receiptentMails = val;
  }

  setMailType(val) {
    this.mailType = val;
  }
  setMailTemplate(val) {
    this.mailTemplate = val;
  }
  setJobPostEditable = (value) => {
    this.jobPostEditable = value ?? false;
  };
  setSkillsField(val) {
    this.skillsField = val;
  }
  setFilter(value) {
    this.filter = value;
  }
  setResumeScore(val) {
    this.resumeScore = val;
  }
  setTechnicalCount(val) {
    this.count = val;
  }
  setInterviewType(val) {
    this.interviewType = val;
  }
  setCompletionStatus(val) {
    this.completionStatus = val;
  }
  setApplicantSearch(val) {
    console.log(val);
    this.applicantSearch = val;
  }
  setAppliedDate(val) {
    this.appliedDate = val;
  }
  setAppliedFor(val) {
    this.appliedFor = val;
  }
  setStatus(val) {
    this.status = val;
  }
  setStatus1(val) {
    this.status = val;
  }

  setScore(val) {
    this.score = val;
  }
  resetFilter() {
    this.completionStatus = "";
    this.interviewType = "";
    this.appliedDate = "";
    this.appliedFor = "";
    this.status = "";
    this.score = "";
    this.fetchapplicants();
  }
  clearFilterState() {
    this.completionStatus = "";
    this.interviewType = "";
    this.appliedDate = "";
    this.appliedFor = "";
    this.status = "";
    this.score = "";
  }
  setInterviewApplicants(val) {
    this.InterviewApplicants = val;
    this.applicantcount = val?.length || 0;
  }
  setJDID = (val) => {
    this.jdId = val;
  };
  setGeneraterLoader(val) {
    this.generaterLoader = val;
  }
  setJob(val) {
    this.job = val;
  }
  setClientId(val) {
    this.clientId = val;
    this.fetchJobPostsForHistory(true);
    this.fetchCompanyInvitations(true);
  }

  setApplicantSkip(skip) {
    this.applicantskip = skip;
  }

  setJobListPage = (value) => {
    this.jobListPage = value;
  };

  setRecuirterJobApplicantSkip(skip) {
    this.recuirterjobapplicantskip = skip;
  }
  setRecuirterJobApplicantLimit(limit) {
    this.recuirterjobapplicantlimit = limit;
  }

  setRecuirterJobPostSkip(skip) {
    this.recuirterjobpostskip = skip;
  }
  setRecuirterJobPostLimit(limit) {
    this.recuirterjobpostlimit = limit;
  }
  setRecuirterInterviewSkip(skip) {
    this.recuirterinverviewskip = skip;
  }
  setRecuirterInterviewLimit(limit) {
    this.recuirterinverviewlimit = limit;
  }
  resetskip() {
    this.recuirterjobpostskip = 0;
    this.recuirterjobpostlimit = 12;
    this.recuirterinverviewskip = 0;
    this.recuirterinverviewlimit = 10;
  }

  setJobPostId(id) {
    this.jobPostId = id;
  }

  setJobPosts(posts) {
    this.jobPosts = posts;
    console.log("job posts");
  }

  jobPostApplicant = null;

  setJobPostApplicant(applicant) {
    this.jobPostApplicant = applicant;
  }

  jobApplications = [];

  setJobApplications = (applications) => {
    this.jobApplications = applications;
  };

  jobPostDetails = {
    basicJobDetails: {
      jobType: "",
      jobTitle: "",
      location: [],
      experience: [],
      workMode: "",
      openings: null,
      salary: {
        isSalaryDisclosed: true,
        showPayBy: "",
        currency: "",
        min: "",
        max: "",
        rate: "",
      },
      resumeCutoff: "",
      jobDescription: "",
      responsibilities: "",
      requiredSkills: [],
      parttime: "",
      qualification: "",
      noticePeriod: null,
      prescreeningQuestions: [],
      otherPlatforms: [],
      isOtherPlatformsEnabled: false,
      roleType: "technical",
      companyName: this.getCurrentUser()?.companyName || "",
      companyLogo: this.getCurrentUser()?.pic || "",
      companyWebsite: "",
      aboutCompany: "",
    },
    customSettings: [
      {
        name: "video",
        value: false,
      },
      {
        name: "resume",
        value: false,
      },
      {
        name: "screen",
        value: false,
      },
      {
        name: "typing",
        value: false,
      },
      {
        name: "mobile",
        value: false,
      },
      {
        name: "actualAnswers",
        value: false,
      },
      {
        name: "report",
        value: false,
      },
      {
        name: "proxy",
        value: false,
      },
      {
        name: "showJobPost",
        value: false,
      },
      {
        name: "scheduleAssessment",
        value: false,
      },
      {
        name: "startDate",
        value: "",
      },
      {
        name: "endDate",
        value: "",
      },
      {
        name: "aiVoice",
        value: 3,
      },
      {
        name: "candidatePay",
        value: false,
      },
      {
        name: "tabChange",
        value: false,
      },
      {
        name: "fullScreen",
        value: true,
      },
      {
        name: "restrictAssessments",
        value: false,
      },
      {
        name: "showReport",
        value: true,
      },
    ],

    mcqTestDetails: {
      testName: "",
      numberOfQuestions: "",
      cutOff: "",
      sections: [
        { name: "Aptitude", questions: null },
        { name: "Technical", questions: null },
        { name: "Reasoning", questions: null },
        { name: "Verbal", questions: null },
      ],
      skipped: false,
      resumeCutoff: "",
      additionalSettings: {
        attempts: 1,
      },
    },
    technicalInterviewDetails: {
      technicalInterviewType: "",
      technology: "",
      technicalInterviewLevel: "",
      technicalNumberOfQuestions: null,
      noOfFollowUps: 3,
      noOfIntroQuestions: 3,
      allQuestions: null,
      interviewId: null,
      technicalCustomquestions: [],
      additionalSettings: {
        camera: false,
        screen: false,
        resume: false,
        attempts: 1,
      },
      skipped: false,
      whoPayCheck: false,
      resumeCutoff: "",
    },
    hrInterviewDetails: {
      interviewType: "",
      technology: "",
      interviewId: null,
      interviewLevel: "",
      numberOfQuestions: null,
      noOfFollowUps: 3,
      noOfIntroQuestions: 3,
      allQuestions: null,
      customquestions: [],
      additionalSettings: {
        camera: false,
        screen: false,
        resume: false,
        attempts: 1,
      },
      skipped: false,
      whoPayCheck: false,
      resumeCutoff: "",
    },
    taskDetails: {
      title: "",
      description: "",
      technologyUsed: [],
      levelOfAssessment: "",
      assessmentType: "",
      duration: "",
      githubLink: "",
      media: [],
      isInvitation: true,
      skipped: false,
      languageId: null,
      noOfQuestions: null,
      questionBank: [],
      tasksBank: [],
      cutOff: "",
    },
  };

  setTaskDetails(key, value) {
    this.jobPostDetails.taskDetails[key] = value;
  }

  resetTaskDetails() {
    this.jobPostDetails.taskDetails = {
      title: "",
      description: "",
      technologyUsed: [],
      levelOfAssessment: "",
      assessmentType: "",
      duration: "",
      githubLink: "",
      media: [],
      isInvitation: true,
      skipped: false,
      tasksBank: [],
    };
  }

  setJobPostCustomSettings(key, value) {
    const existingSetting = this.jobPostDetails.customSettings.find(
      (setting) => setting?.name === key,
    );
    if (existingSetting) {
      existingSetting.value = value;
    } else {
      // Add new setting if it doesn't exist
      this.jobPostDetails.customSettings.push({
        name: key,
        value: value,
      });
    }
  }

  ResetJobPostCustomSettings() {
    this.jobPostDetails.customSettings = [
      {
        name: "video",
        value: false,
      },
      {
        name: "resume",
        value: false,
      },
      {
        name: "screen",
        value: false,
      },
      {
        name: "typing",
        value: false,
      },
      {
        name: "mobile",
        value: false,
      },
      {
        name: "actualAnswers",
        value: false,
      },
      {
        name: "report",
        value: false,
      },
      {
        name: "proxy",
        value: false,
      },
      {
        name: "showJobPost",
        value: false,
      },
      {
        name: "scheduleAssessment",
        value: false,
      },
      {
        name: "startDate",
        value: null,
      },
      {
        name: "endDate",
        value: null,
      },
      {
        name: "aiVoice",
        value: 3,
      },
      {
        name: "candidatePay",
        value: false,
      },
      {
        name: "tabChange",
        value: false,
      },
      {
        name: "fullScreen",
        value: true,
      },
      {
        name: "restrictAssessments",
        value: false,
      },
      {
        name: "showReport",
        value: true,
      },
      {
        name: "attempts",
        value: 1,
      },
    ];
  }

  setMcqAdditionalSettings(key, value) {
    this.jobPostDetails.mcqTestDetails.additionalSettings[key] = value;
  }

  resetJobPostData() {
    // Reset basic job details
    this.jobPostDetails.basicJobDetails = {
      jobType: "",
      jobTitle: "",
      location: "",
      experience: [],
      workMode: "",
      openings: null,
      salary: {
        showPayBy: "",
        currency: "",
        min: "",
        max: "",
        rate: "",
      },
      resumeCutoff: "",
      jobDescription: "",
      responsibilities: "",
      requiredSkills: [],
      parttime: "",
      qualification: "",
      noticePeriod: null,
      prescreeningQuestions: [],
      otherPlatforms: [],
      isOtherPlatformsEnabled: false,
      roleType: "technical",
      companyName: this.user?.companyName || "",
      companyLogo: this.user?.pic || "",
      companyWebsite: "",
      aboutCompany: "",
    };

    // Reset custom settings
    this.ResetJobPostCustomSettings();

    // Reset MCQ test details
    this.jobPostDetails.mcqTestDetails = {
      testName: "",
      numberOfQuestions: "",
      cutOff: "",
      sections: [
        { name: "Aptitude", questions: null },
        { name: "Technical", questions: null },
        { name: "Reasoning", questions: null },
        { name: "Verbal", questions: null },
      ],
      skipped: false,
      resumeCutoff: "",
      additionalSettings: {
        attempts: 1,
      },
    };

    // Reset technical interview details
    this.jobPostDetails.technicalInterviewDetails = {
      technicalInterviewType: "",
      technology: "",
      technicalInterviewLevel: "",
      technicalNumberOfQuestions: null,
      noOfFollowUps: 3,
      noOfIntroQuestions: 3,
      noOfCustomQuestions: 0,
      allQuestions: null,
      interviewId: null,
      technicalCustomquestions: [],
      additionalSettings: {
        camera: false,
        screen: false,
        resume: false,
        attempts: 1,
      },
      skipped: false,
      whoPayCheck: false,
      resumeCutoff: "",
    };

    // Reset HR interview details
    this.jobPostDetails.hrInterviewDetails = {
      interviewType: "",
      technology: "",
      interviewId: null,
      interviewLevel: "",
      numberOfQuestions: null,
      noOfFollowUps: 3,
      noOfIntroQuestions: 3,
      noOfCustomQuestions: 0,
      allQuestions: null,
      customquestions: [],
      additionalSettings: {
        camera: false,
        screen: false,
        resume: false,
        attempts: 1,
      },
      skipped: false,
      whoPayCheck: false,
      resumeCutoff: "",
    };

    // Reset task details
    this.jobPostDetails.taskDetails = {
      title: "",
      description: "",
      technologyUsed: [],
      levelOfAssessment: "",
      assessmentType: "",
      duration: "",
      githubLink: "",
      media: [],
      isInvitation: true,
      skipped: false,
      languageId: null,
      tasksBank: [],
    };

    // Reset job post ID
    // this.jobPostId = null;
  }

  setsalarydetails(key, value) {
    this.jobPostDetails.basicJobDetails.salary[key] = value;
  }

  setBasicJobDetails(key, value) {
    this.jobPostDetails.basicJobDetails[key] = value;
  }

  setMcqTestDetails(key, value) {
    this.jobPostDetails.mcqTestDetails[key] = value;
  }

  setTechnicalInterviewDetails(key, value) {
    // if (key === "noOfIntroQuestions") {
    //   this.jobPostDetails.technicalInterviewDetails.allQuestions =
    //     Number(
    //       this.jobPostDetails.technicalInterviewDetails
    //         .technicalNumberOfQuestions
    //     ) +
    //     Number(this.jobPostDetails.technicalInterviewDetails.noOfFollowUps) +
    //     Number(value);
    // } else if (key === "noOfFollowUps") {
    //   this.jobPostDetails.technicalInterviewDetails.allQuestions =
    //     Number(
    //       this.jobPostDetails.technicalInterviewDetails.noOfIntroQuestions
    //     ) +
    //     Number(
    //       this.jobPostDetails.technicalInterviewDetails
    //         .technicalNumberOfQuestions
    //     ) +
    //     Number(value);
    // } else if (key === "technicalNumberOfQuestions") {
    //   this.jobPostDetails.technicalInterviewDetails.allQuestions =
    //     Number(
    //       this.jobPostDetails.technicalInterviewDetails.noOfIntroQuestions
    //     ) +
    //     Number(this.jobPostDetails.technicalInterviewDetails.noOfFollowUps) +
    //     Number(value);
    // }
    this.jobPostDetails.technicalInterviewDetails[key] = value;
  }

  setHrInterviewDetails(key, value) {
    // if (key === "noOfIntroQuestions") {
    //   this.jobPostDetails.hrInterviewDetails.allQuestions =
    //     Number(this.jobPostDetails.hrInterviewDetails.noOfQuestions) +
    //     Number(this.jobPostDetails.hrInterviewDetails.noOfFollowUps) +
    //     Number(value);
    // } else if (key === "noOfFollowUps") {
    //   this.jobPostDetails.hrInterviewDetails.allQuestions =
    //     Number(this.jobPostDetails.hrInterviewDetails.noOfIntroQuestions) +
    //     Number(this.jobPostDetails.hrInterviewDetails.noOfQuestions) +
    //     Number(value);
    // } else if (key === "numberOfQuestions") {
    //   this.jobPostDetails.hrInterviewDetails.allQuestions =
    //     Number(this.jobPostDetails.hrInterviewDetails.noOfIntroQuestions) +
    //     Number(this.jobPostDetails.hrInterviewDetails.noOfFollowUps) +
    //     Number(value);
    // }

    this.jobPostDetails.hrInterviewDetails[key] = value;
  }

  setMcqSections(key, index, value) {
    this.jobPostDetails.mcqTestDetails.sections[index][key] = value;
    // let totalQuestions = 0;
    // this.jobPostDetails.mcqTestDetails.sections.forEach((section) => {
    //   totalQuestions += section.questions;
    // });
    // this.jobPostDetails.mcqTestDetails.numberOfQuestions = totalQuestions;
  }

  settechnicalAdditionalSettings(key, value) {
    this.jobPostDetails.technicalInterviewDetails.additionalSettings[key] =
      value;
  }

  sethrAdditionalSettings(key, value) {
    this.jobPostDetails.hrInterviewDetails.additionalSettings[key] = value;
  }

  autofillJobPostDetails(basicDetails) {
    // Basic Job Details
    Object.entries(basicDetails).forEach(([key, value]) => {
      if (key === "sections" && Array.isArray(value)) {
        value.forEach((section, index) => {
          Object.entries(section).forEach(([sectionKey, sectionValue]) => {
            this.setMcqSections(sectionKey, index, sectionValue);
          });
        });
      } else {
        this.jobPostDetails.basicJobDetails[key] = value;
      }
    });
  }

  hittedApis = {
    users: false,
    companyInvitations: false,
    allApplicants: false,
    jobPosts: false,
    jobPostApplications: false,
    allInvitations: false,
    mockTest: false,
  };
  jobData = {};
  loader = false;
  technology = {};
  Users = [];
  filteredUsers = [];
  companyInvitations = [];
  applicants = [];
  allApplicants = [];
  filteredApplicants = [];
  selectedInvitationId = null;
  applicantsData = { result: [] };
  assessmentType = "applicants";

  // for pagination
  currentPage = 1;
  totalPage = 3;
  search = null;
  LookingFor = null;
  city = null;
  applicantInterviews = [];
  showLoader = false;
  generateParams = {
    title: "",
    minexp: "",
    maxexp: "",
    mode: "workFromOffice",
    salary: "",
    skills: [],
    qualification: "",
  };
  generatedJD = "";
  jobDescription = "";

  resumeLength = 0;
  clientsInfo = {};
  recentActivity = [];
  coinsUsage = {};
  topApplicants = [];
  pdfLink = "";
  jdID = "";
  jdType = "Sorted";
  searchHistoryJobPost = "";
  searchHistoryInterviews = "";
  searchHistoryMcqData = "";
  searchHistoryResumeAnalyzer = "";
  LoadedInvitations = [];
  AllowError = true;
  RemaindedAssessment = [];
  setAllowError(val) {
    this.AllowError = val;
  }

  setHistoryMcqDataSearch(val) {
    this.searchHistoryMcqData = val;
  }
  setHistoryResumeAnalyzerSearch(val) {
    this.searchHistoryResumeAnalyzer = val;
  }
  setHistoryInterviewSearch(val) {
    this.searchHistoryInterviews = val;
  }

  setHistoryJobPostSearch(val) {
    this.searchHistoryJobPost = val;
  }
  setJDType(val) {
    this.jdType = val;
  }
  setJDId(val) {
    this.jdID = val;
  }
  setPdfLink(val) {
    this.pdfLink = val;
  }
  setResumeCount(val) {
    this.resumeCount = val;
  }
  setGeneratedJD(val) {
    this.generatedJD = val;
  }
  setJobDescription(val) {
    this.jobDescription = val;
  }
  ClearGenerateParams(key, val) {
    this.generateParams = {
      title: "",
      minexp: "",
      maxexp: "",
      mode: "",
      openings: "",
      skills: [],
      qualification: "",
    };
  }
  SetGenerateParams(key, val) {
    this.generateParams[key] = val;
  }

  setShowLoader(value) {
    this.showLoader = value;
  }

  jobPostApplications = [];

  setJobPostApplications(applications) {
    this.jobPostApplications = applications;
  }

  // setJobPosts(jobPosts){
  //   this.jobPosts = jobPosts;
  // }

  limit = 9;
  count = 0;
  tech = "";
  setTech(tech) {
    this.tech = tech;
  }
  setApplicants(applicants) {
    this.applicants = applicants;
  }
  setCount(count) {
    this.count = count;
  }
  totalProfiles = 0;
  setTotalProfiles(totalProfiles) {
    this.totalProfiles = totalProfiles;
  }

  setTechnology(technology) {
    this.technology = technology;
  }

  setLookingFor(lookingFor) {
    this.LookingFor = lookingFor;
  }
  setFilteredUsers(users) {
    this.filteredUsers = users;
  }
  setcity(city) {
    this.city = city;
  }
  setSearching(search) {
    this.search = search;
  }

  setUsers(users) {
    this.Users = users;
  }
  showAllUsers = () => {
    this.filteredUsers = this.Users;
  };

  setLoader = (value) => {
    this.loader = value ?? true;
  };
  setAssessmentType = (value) => {
    this.assessmentType = value;
    const keyMap = {
      applicants: "clientApplicants",
      jobposts: "clientJobPosts",
      interviews: "clientInterviews",
      resumes: "clientResumes",
    };
    const key = keyMap[value];
    if (key && this.applicantsData && Array.isArray(this.applicantsData[key])) {
      this.applicantsData = {
        ...this.applicantsData,
        result: this.applicantsData[key],
      };
    }
  };

  isEdit = false;
  setIsEdit = (value) => {
    this.isEdit = value;
  };
  async searchUsers() {
    this.currentPage = 1;
    this.totalPage = 3;
    this.Users = [];
    await this.searchOrLoadMoreUsersFromServer();
  }

  async loadMoreUsers() {
    this.currentPage++;
    await this.searchOrLoadMoreUsersFromServer();
  }

  async fetchCoinsUsage() {
    const userId = this.getCurrentUserId();
    if (!userId) return false;
    this.setLoader(true);
    const response = await apiGet(`${DASHBOARD_BASE}/coins-usage`);
    this.setLoader(false);
    if (response.status === 200 && response.body?.success) {
      const body = response.body;
      runInAction(() => {
        this.coinsUsage = body.data ?? body;
      });
      return true;
    }
    return false;
  }

  async fetchTopApplicants() {
    const userId = this.getCurrentUserId();
    if (!userId) return false;
    this.setLoader(true);
    const response = await apiGet(
      `${DASHBOARD_BASE}/top-talent?skip=0&limit=10`,
    );
    this.setLoader(false);
    if (response.status === 200 && response.body?.success) {
      const data = response.body.data ?? [];
      runInAction(() => {
        this.topApplicants = data.map((item) => ({
          userId: {
            name: item.name,
            pic: item.pic,
          },
          jobPostId: { jobTitle: item.title ?? item.college },
          averageScore: item.score,
          createdAt: item.createdAt,
          resume: item.resume ?? item.resumeLink,
        }));
      });
      return true;
    }
    return false;
  }
  async fetchRemainderMails(id, type) {
    const response = await apiPostPut(
      {
        id: id,
        type: type,
      },
      "/v1/recruiter/reminders/emails",
      "POST",
    );

    if (response.status === 200) {
      this.remainderMails =
        response.body.data?.data || response.body.data || [];
      return true;
    } else {
      return false;
    }
  }

  async fetchRecentActivity() {
    const userId = this.getCurrentUserId();
    if (!userId) return false;
    this.setLoader(true);
    const response = await apiGet(
      `${DASHBOARD_BASE}/recent-activity?t=${Date.now()}`,
    );
    this.setLoader(false);
    if (response.status === 200 && response.body?.success) {
      const data = response.body.data;
      const activityArray = Array.isArray(data)
        ? data
        : Array.isArray(data?.activity)
          ? data.activity
          : [];
      runInAction(() => {
        this.recentActivity = activityArray;
        const first = activityArray[0];
        if (first) {
          this.latestActivity = {
            ...first,
            title: first.name,
            totalApplicants: first.applicants ?? 0,
            recentApplicantCount: first.recentAppliedCount ?? 0,
            applicants:
              first.recentApplicants || first.applicants_details || [],
            type: first.type === "jobpost" ? "jobPost" : first.type,
          };
          this.latestActivityVisible = !this.closeActivity;
        } else {
          this.latestActivityVisible = false;
        }
      });
      return true;
    }
    return false;
  }

  async fetchClientsInfo() {
    const userId = this.getCurrentUserId();
    if (!userId) return false;
    this.setLoader(true);
    const response = await apiGet(`${DASHBOARD_BASE}/metrics`);
    this.setLoader(false);
    if (response.status === 200 && response.body?.success) {
      runInAction(() => {
        this.clientsInfo = response.body.data;
      });
      return true;
    }
    return false;
  }

  async fetchLatestActivity() {
    return this.fetchRecentActivity();
  }

  async generateEvaluation(id) {
    const response = await generateApplicantEvaluation(id);
    if (response.status === 200) {
      return true;
    } else {
      return false;
    }
  }

  async updateApplicantInterviewFeedback(id, feedback) {
    const response = await updateApplicationDetail(id, {
      interviewFeedback: feedback,
    });
    if (response.status === 200) {
      return true;
    } else {
      return false;
    }
  }

  async updateApplicantResume(id, resume) {
    const response = await updateApplicationDetail(id, { resume: resume });
    if (response.status === 200) {
      alert("Resume updated successfully it will be reflected in 1-2 minutes");
      return true;
    } else {
      alert("Something went wrong. Please try again later");
      return false;
    }
  }

  async updateApplicantRestriction(id, isRestricted) {
    const response = await updateApplicationDetail(id, {
      isRestricted: isRestricted,
    });
    if (response.status === 200) {
      return true;
    } else {
      return false;
    }
  }

  async updateApplicantProxyReasons(id, proxyReasons) {
    const response = await updateApplicationDetail(id, {
      proxyReasons: proxyReasons,
    });
    if (response.status === 200) {
      return true;
    } else {
      return false;
    }
  }

  async updateApplicantTaskDuration(id, taskDuration) {
    const response = await updateApplicationDetail(id, {
      taskDuration: taskDuration,
    });
    if (response.status === 200) {
      await this.fetchApplicantDetails(id);
      return true;
    } else {
      return false;
    }
  }

  async updateApplicantMailDetails(
    id,
    purpose,
    subject,
    content,
    status,
    prev,
  ) {
    console.log(prev, "this is job applications");
    const body = {
      mailDetails: [
        ...prev,
        {
          purpose:
            purpose === 0
              ? "hold"
              : purpose === 1
                ? "shortlisted"
                : purpose === 2
                  ? "rejected"
                  : purpose === 3
                    ? "hired"
                    : purpose === 4
                      ? "proxy"
                      : "remainder",
          subject,
          content,
          status,
        },
      ],
    };

    const response = await updateApplicationDetail(id, body);
    if (response.status === 200) {
      this.getApplicantProgress(id);
      return true;
    } else {
      return false;
    }
  }

  async fetchAllTeamMembers(params = {}) {
    this.setLoader(true);
    const response = await getAllTeamMembers(params);
    this.setLoader(false);
    if (response.status === 200) {
      this.setTeams(response.body.data);
      return true;
    } else {
      return false;
    }
  }

  async addMember(data) {
    //"6551bda478cf4fd1e4316dc9" add employer to data
    data.employer = "6551bda478cf4fd1e4316dc9";
    try {
      this.setLoader(true);
      const response = await apiPostPutPublic(
        data,
        "/user/send-verification-email",
        "POST",
      );
      this.setLoader(false);
      if (response.status === 200) {
        this.fetchAllTeamMembers();
        return true;
      } else {
        this.setLoader(false);
        alert(response.body.message);
        return false;
      }
    } catch (error) {
      this.setLoader(false);
    }
  }

  async updateMember(data, id) {
    try {
      this.setLoader(true);
      const response = await apiPostPut(
        data,
        `/invitations/update-invitation/${id}`,
        "PUT",
      );
      this.setLoader(false);
      if (response.status === 200) {
        this.fetchAllTeamMembers();
        return true;
      } else {
        this.setLoader(false);
        alert(response.body.message);
        return false;
      }
    } catch (error) {
      this.setLoader(false);
    }
  }

  async fetchApplicantsData() {
    const userId = this.getCurrentUserId();
    if (!userId) return false;
    this.setLoader(true);
    const response = await apiGet(`${DASHBOARD_BASE}/tracking`);
    this.setLoader(false);
    if (response.status === 200 && response.body?.success) {
      const body = response.body;
      const clientJobPosts = body.clientJobPosts ?? [];
      const clientInterviews = body.clientInterviews ?? [];
      const clientResumes = body.clientResumes ?? [];
      const clientApplicants = body.clientApplicants ?? [];
      const keyMap = {
        applicants: "clientApplicants",
        jobposts: "clientJobPosts",
        interviews: "clientInterviews",
        resumes: "clientResumes",
      };
      const key = keyMap[this.assessmentType] ?? "clientApplicants";
      const result =
        key === "clientApplicants"
          ? clientApplicants
          : key === "clientJobPosts"
            ? clientJobPosts
            : key === "clientInterviews"
              ? clientInterviews
              : clientResumes;
      this.applicantsData = {
        clientJobPosts,
        clientInterviews,
        clientResumes,
        clientApplicants,
        result,
      };
      return true;
    }
    return false;
  }

  async fetchResumeScoreAPI(applicationId, ResumeContent) {
    const response = await apiPostPut(
      {
        resumeContent: ResumeContent,
        applicationId: applicationId,
      },
      `/v1/recruiter/applications/resume-score`,
      "PUT",
    );
    if (response.status === 200) {
      this.resumeScoreDataCount = response.body.data.resumeScore;
      console.log("resume score", response.body.data.resumeScore);
      return true;
    } else {
      return console.log("something went wrong");
    }
  }

  async fetchAllInvitations(skip = 0, searchFilter = undefined) {
    const userId = this.getCurrentUserId();
    if (!userId) return false;
    this.setLoader(true);
    const response = await getRecruiterInvitations({
      skip,
      limit: 10,
      clientId: this.clientId || undefined,
      searchFilter:
        searchFilter !== undefined && searchFilter !== ""
          ? searchFilter
          : undefined,
    });
    this.setLoader(false);
    this.hittedApis.allInvitations = true;

    if (response.status === 200 && response.body?.success) {
      this.allInvitations = {
        ...response.body,
        data: response.body?.data ?? [],
      };
      return true;
    }
    return false;
  }

  async fetchCompanyInvitations(refresh = false, interviewType = undefined) {
    console.log(
      "fetching company invitations",
      this.hittedApis.companyInvitations,
    );
    if (this.hittedApis.companyInvitations && !refresh && !interviewType)
      return;
    const userId = this.getCurrentUserId();
    if (!userId) return false;
    this.setLoader(true);
    console.log("kartyhik", this.clientId);
    const response = await getCompanyInterviewInvitations({
      skip: this.recuirterinverviewskip,
      limit: this.recuirterinverviewlimit,
      clientId: this.clientId ? this.clientId : undefined,
      interviewType: interviewType || undefined,
      searchFilter: this.searchHistoryInterviews
        ? this.searchHistoryInterviews
        : undefined,
    });
    this.setLoader(false);
    this.hittedApis.companyInvitations = true;
    console.log("response", response);
    if (response.status === 200) {
      console.log("company interviews--", response.body?.data);
      this.recuirterinverviewcount = response.body?.count;

      // this.hittedApis.companyInterviews = true;
      this.companyInvitations = response.body?.data;
      console.log("company interviews", this.companyInvitations);
      this.hittedApis.companyInvitations = true;
      this.setHistoryInterviewSearch("");
    } else {
      this.hittedApis.companyInvitations = false;
      return console.log("something went wrong");
    }
  }

  async fetchjd(skip = 0) {
    this.loader = true;
    const userId = this.getCurrentUserId();
    if (!userId) {
      this.loader = false;
      return false;
    }
    const response = await getRecruiterJds({
      skip,
      limit: 10,
      searchFilter: this.searchHistoryResumeAnalyzer
        ? this.searchHistoryResumeAnalyzer
        : undefined,
    });
    if (response.status === 200) {
      this.jd = response.body?.data;
      this.resumeCount = response.body?.count;
      this.setHistoryResumeAnalyzerSearch("");
    } else {
      alert(response.body?.message);
    }
    this.loader = false;
  }

  async fetchApplicantInterviews(id, clientId) {
    if (!id) {
      id = localStorage.getItem("applicantId");
    }
    if (!clientId) {
      clientId = this.clientId;
    }
    try {
      const response = await apiGet(
        `/interview/user-interviews/${id}?clientId=${clientId}`,
      );
      if (response.status === 200) {
        console.log("dashboard", response.body?.data);
        return this.setApplicantInterviews(response.body?.data);
      } else {
        return console.log("something went wrong");
      }
    } catch (error) {
      console.error("Error:", error); // Log the error for debugging
      return console.log("something went wrong");
    }
  }

  async updatejd(name, id) {
    this.loader = true;
    const response = await apiPostPut(
      { name: name },
      `/jds/update-jd/${id}`,
      "PUT",
    );
    if (response.status === 200) {
      alert("Name updated sucessfull");

      this.loader = false;
      this.fetchjd();
    } else {
      alert("Something went wrong . Please try again later");
      this.loader = false;
    }
  }

  async fetchResumeScore(skip = 0, ID = this.jdId, limit = 10) {
    console.log("Fetching resume score with params:", { skip, ID, limit });
    try {
      if (!ID) {
        console.error("No JD ID provided for resume score fetch");
        return;
      }

      this.loader = true;
      const response = await getResumeScoresByJd(ID, { skip, limit });
      console.log("API Response:", response);

      if (response.status === 200) {
        // Transform the response data into the expected format
        const transformedData = {
          data: {
            resumes: (response.body.data || []).map((resume) => ({
              _id: resume?._id || "",
              name: resume?.name || "",
              email: resume?.email || "",
              experience: resume?.experience || 0,
              match: [
                {
                  score: resume?.score || 0,
                  suggestion: resume?.suggestion || "",
                },
              ],
              link: resume?.link || "",
              labels: resume?.labels || [],
              status: resume?.status || "",
              extractionStatus: resume?.extractionStatus || 2,
              description: resume?.content || "",
              jdId: resume?.jdId?._id || "",
              jdName: resume?.jdId?.name || "",
              jdDescription: resume?.jdId?.jd || "",
              scoreDetails: resume?.scoreDetails || [],
              technology: resume?.jdId?.technology || "",
              jobDescription: resume?.jdId?.jobDescription || "",
              requiredSkills: resume?.jdId?.skills || [],
              requiredExperience: resume?.jdId?.requiredExperience || {
                minimum: 0,
                maximum: 0,
              },
              workMode: resume?.jdId?.workMode || "",
              jobLocation: resume?.jdId?.jobLocation || "",
              // jobType: resume?.jdId?.jobType || "",
              qualification: resume?.jdId?.qualification || "",
              jobTitle: resume?.jdId?.jobTitle || "",
              salary: resume?.jdId?.salary || {},
              // Additional fields from the API response
              phone: resume?.phone || "",
              github: resume?.github || "",
              linkedIn: resume?.linkedIn || "",
              skills: resume?.skills || [],
              projects: resume?.projects || [],
              education: resume?.education || [],
              internships: resume?.internships || [],
              city: resume?.city || "",
              country: resume?.country || "",
              profileSummary: resume?.profileSummary || "",
            })),
            isSortingCompleted: true,
            isExtractionCompleted: true,
          },
          count: response.body.count || 0,
        };
        console.log("transformedData", transformedData);

        this.resumeScore = transformedData;
        this.loader = false;
      } else {
        console.error("API Error:", response.body?.message);
        this.loader = false;
      }
    } catch (error) {
      console.error("API Call Failed:", error);
      this.loader = false;
    }
  }

  async fetchLanguages() {
    const response = await apiGet(`/code-editor/languages`);
    if (response.status === 200) {
      return response.body;
    }
  }

  async compileCode(code, languageId, stdin) {
    const response = await apiPostPut(
      {
        sourceCode: code,
        languageId,
        stdin,
      },
      `/code-editor/compile`,
      "POST",
    );
    if (response.status === 200) {
      return response.body;
    }
  }

  async fetchClients(id) {
    const userId = this.getCurrentUserId();
    if (!userId) return false;
    const response = await apiGet(`/clients/get-client/${userId}`);

    if (response.status === 200) {
      this.clients = response.body;
      return true;
    } else {
      return false;
    }
  }
  async deleteClient(id) {
    this.setLoader(true);
    const response = await apiDelete(`/clients/delete-client/${id}`);
    this.setLoader(false);
    if (response.status === 200) {
      console.log("client deleted", response?.body?.data);
      this.fetchClients();
      return true;
    } else {
      return console.log("something went wrong");
    }
  }

  async updateCompanyInvitation(status, id) {
    this.setLoader(true);
    const response = await updateInterview(id, { isOpen: status });
    this.setLoader(false);
    if (
      (response.status === 200 || response.status === 201) &&
      response?.body?.success
    ) {
      console.log("company invitation updated", response?.body?.data);
      this.allInvitations.data.filter((item) => {
        if (item._id === id) {
          item.isOpen = response?.body?.data?.isOpen;
        }
      });
      const index = this.companyInvitations.findIndex(
        (invitation) => invitation?._id === id,
      );
      this.companyInvitations[index].isOpen = response?.body?.data?.isOpen;
      return true;
    } else {
      return console.log("something went wrong");
    }
  }

  async fetchJobPostsForHistory(refresh = false) {
    console.log("fetching job posts", this.hittedApis.jobPosts);
    if (this.hittedApis.jobPosts && !refresh) return;
    const userId = this.getCurrentUserId();
    if (!userId) return false;
    this.setLoader(true);
    const response = await listJobPosts({
      skip: this.recuirterjobpostskip,
      limit: this.recuirterjobpostlimit,
      clientId: this.clientId || undefined,
      searchFilter: this.searchHistoryJobPost || undefined,
    });
    this.setLoader(false);
    console.log("response", response);
    if (response.status === 200 && response.body?.success) {
      console.log("job posts--", response.body?.data);
      this.recuirterjobpostcount = response.body?.count;
      this.setJobPosts(response.body?.data ?? []);
      console.log("job posts", toJS(this.jobPosts));
      this.hittedApis.jobPosts = true;
      this.setHistoryJobPostSearch("");
    } else {
      this.hittedApis.jobPosts = false;
      return console.log("something went wrong");
    }
  }
  async fetchmcqinvitation(skip = 0) {
    this.loader = true;
    const id = this.getCurrentUserId();
    if (!id) {
      this.loader = false;
      return false;
    }
    const response = await getMockTestInvitations({
      skip,
      limit: 10,
      clientId: this.clientId ? this.clientId : undefined,
      searchFilter: this.searchHistoryMcqData
        ? this.searchHistoryMcqData
        : undefined,
    });
    this.hittedApis.mockTest = true;
    if (response.status === 200) {
      this.mockTest = response.body?.data;
      this.mcqcount = response.body?.count;
      this.setHistoryMcqDataSearch("");
    } else {
      console.log(response.body?.message);
    }
    this.loader = false;
  }

  async getApplicantProgress(id) {
    if (!id || id === "undefined" || id === "") {
      this.setApplicantProgres([]);
      return;
    }
    this.setApplicantProgres([]);
    const response = await getApplicationTracking(id);
    if (response.status === 200) {
      console.log("applicant progress--", response?.body?.data);
      const raw = response?.body?.data;

      // The new tracking API returns a flat object. Transform it into the
      // array format the UI expects (each element has { label, ... }).
      let progressArray = [];
      if (Array.isArray(raw)) {
        // If the backend already returns an array, use it directly
        progressArray = raw;
      } else if (raw && typeof raw === "object") {
        // Transform the flat tracking object into progress items
        if (raw.mockTest) {
          progressArray.push({
            label: "mockTest",
            isCompleted: raw.mockTest.isCompleted || false,
            score:
              raw.mockTest.overall ??
              raw.mockTest.categoryWiseReport?.overall?.accuracy ??
              0,
            cutOff: raw.mockTest.cutOff || 0,
            createdAt: raw.mockTest.createdAt,
          });
        }
        if (raw.technicalInterview) {
          const techResult = raw.technicalInterview.result;
          const techScore =
            Array.isArray(techResult) && techResult.length > 0
              ? (techResult[techResult.length - 1]?.score ?? 0)
              : 0;
          progressArray.push({
            label: "technicalInterview",
            isCompleted: raw.technicalInterview.isInterviewCompleted || false,
            isResultPublished:
              raw.technicalInterview.isResultPublished || false,
            score: techScore,
            cutOff: raw.technicalInterview.cutOff || 0,
            createdAt: raw.technicalInterview.createdAt,
          });
        }
        if (raw.hrInterview) {
          const hrResult = raw.hrInterview.result;
          const hrScore =
            Array.isArray(hrResult) && hrResult.length > 0
              ? (hrResult[hrResult.length - 1]?.score ?? 0)
              : 0;
          progressArray.push({
            label: "hrInterview",
            isCompleted: raw.hrInterview.isInterviewCompleted || false,
            isResultPublished: raw.hrInterview.isResultPublished || false,
            score: hrScore,
            cutOff: raw.hrInterview.cutOff || 0,
            createdAt: raw.hrInterview.createdAt,
          });
        }
        if (raw.codingInterview) {
          progressArray.push({
            label: "codingInterview",
            isCompleted: raw.codingInterview.isCompleted || false,
            score: raw.codingInterview.results?.[0]?.percentage ?? 0,
            cutOff: raw.codingInterview.cutOff || 0,
            createdAt: raw.codingInterview.createdAt,
          });
        }
        if (raw.assessment) {
          progressArray.push({
            label: "assessment",
            isCompleted: raw.assessment.isAssessmentCompleted || false,
            createdAt: raw.assessment.createdAt,
          });
        }
        if (raw.resumeScore != null) {
          progressArray.push({
            label: "resume",
            isCompleted: true,
            score: raw.resumeScore,
            createdAt: raw.createdAt,
          });
        }
        // Preserve mail details if present (for status tracking)
        if (raw.mailDetails && Array.isArray(raw.mailDetails)) {
          raw.mailDetails.forEach((mail) => {
            progressArray.push({
              label: "mailDetails",
              purpose: mail.purpose,
              subject: mail.subject,
              content: mail.content,
              status: mail.status,
              createdAt: mail.createdAt,
            });
          });
        }
      }

      this.setApplicantProgres(progressArray);
      console.log("applicant progress", toJS(this.applicantProgres));
      return response?.body?.data;
    } else {
      return console.log("something went wrong");
    }
  }

  updateMcqStatus = async (status, id) => {
    const response = await updateMockTest(id, { isOpen: status });
    if (
      (response.status === 200 || response.status === 201) &&
      response?.body?.success
    ) {
      this.allInvitations.data.filter((item) => {
        if (item._id === id) {
          item.isOpen = response?.body?.data?.isOpen;
        }
      });
    }
  };

  async updateJobPostStatus(status, id) {
    this.setLoader(true);

    const response = await updateJobPostApi(id, { isOpen: status });

    this.setLoader(false);
    if (response.status === 200 && response.body?.success) {
      console.log("job post updated", response?.body?.data);
      this.allInvitations.data.filter((item) => {
        if (item._id === id) {
          item.isOpen = response?.body?.data?.isOpen;
        }
      });

      const index = this.jobPosts.findIndex((post) => post?._id === id);
      this.jobPosts[index].isOpen = response?.body?.data?.isOpen;
      return true;
    } else {
      return console.log("something went wrong");
    }
  }

  async fetchJobPostApplications(id, body, Load = true) {
    this.loader = Load;
    const response = await getJobApplications(id, {
      skip: this.recuirterjobapplicantskip,
      limit: this.recuirterjobapplicantlimit,
      clientId: this.clientId ? this.clientId : undefined,
      searchFilter: body?.search ? body?.search : undefined,
    });
    if (response.status === 200) {
      this.loader = false;
      console.log("job post applications--", response.body?.data);
      this.recuirterjobapplicantscount = response.body?.count;
      // this.hittedApis.companyInterviews = true;
      this.setJobPostApplications(response.body?.data);
      console.log("job post applications", toJS(this.jobPostApplications));
    } else {
      return console.log("something went wrong");
    }
    this.loader = false;
  }

  async fetchJobPostApplicationsByFilter(id, filters) {
    this.loader = true;
    const body = {
      status: filters.status,
      technical: filters.technicalInterview,
      hr: filters.hrInterview,
      score: Number(filters.totalScore),
    };
    console.log(body, "filters");
    const response = await getJobApplications(id, {
      skip: this.recuirterjobapplicantskip,
      limit: this.recuirterjobapplicantlimit,
      clientId: this.clientId ? this.clientId : undefined,
      hr: filters.hrInterview,
      technical: filters.technicalInterview,
      status: filters.status,
      score: filters.score,
    });
    if (response.status === 200) {
      this.loader = false;
      console.log("job post applications--", response.body?.data);
      this.recuirterjobapplicantscount = response.body?.count;
      // this.hittedApis.companyInterviews = true;
      this.setJobPostApplications(response.body?.data);
      console.log("job post applications", toJS(this.jobPostApplications));
    } else {
      this.loader = false;
      return console.log("something went wrong");
    }
  }

  fetchapplicants = async (skip = 0, limit = 10) => {
    runInAction(() => {
      this.loader = true;
    });
    console.log("FETCH_APPLICANTS_CALLED", { skip, limit });
    const id = this.getCurrentUserId();
    if (!id) {
      runInAction(() => {
        this.loader = false;
      });
      console.log("FETCH_APPLICANTS_FAILED: No ID found");
      return false;
    }
    console.log("FETCH_APPLICANTS_PROCEEDING with ID:", id);
    const params = new URLSearchParams();
    params.set("skip", String(skip));
    params.set("limit", String(limit));
    if (this.clientId) params.set("clientId", this.clientId);
    if (this.status != null && this.status !== "")
      params.set("status", String(this.status));
    if (this.score != null && this.score !== "")
      params.set("score", String(this.score));
    if (this.applicantSearch) params.set("searchFilter", this.applicantSearch);
    if (this.appliedFor) params.set("appliedFor", this.appliedFor);
    if (this.appliedDate) {
      const timestamp = new Date(this.appliedDate).getTime();
      if (!isNaN(timestamp)) params.set("appliedDate", String(timestamp));
    }
    if (this.interviewType) {
      if (this.interviewType === "jobPost") {
        params.set("type", "jobPost");
      } else if (this.interviewType === "mocktest") {
        params.set("type", "mocktest");
      } else {
        params.set("interviewType", this.interviewType);
        params.set("type", "interview");
      }
    }
    if (this.completionStatus)
      params.set("completionStatus", this.completionStatus);

    if (true) {
      console.log(
        "Constructed URL:",
        `${DASHBOARD_BASE}/top-talent?${params.toString()}`,
      );
    }
    const response = await apiGet(
      `${DASHBOARD_BASE}/top-talent?${params.toString()}`,
    );
    console.log("FETCH_APPLICANTS_RESPONSE", response);

    runInAction(() => {
      this.loader = false;
      if (response.status === 200 && response.body?.success) {
        this.jobapplicants = response.body;
      }
    });

    return response.status === 200 && response.body?.success;
  };

  async fetchApplicantDetails(id) {
    const applicantId = id ?? this.jobPostApplications[0]?._id;
    const response = await getApplicationDetail(applicantId, {
      clientId: this.clientId ? this.clientId : undefined,
    });
    if (response.status === 200) {
      console.log("applicant details--", response?.body?.data);
      return this.setJobPostApplicant(response?.body?.data);
    } else {
      return console.log("something went wrong");
    }
  }

  async fetchInterviewDetails(id) {
    this.setLoader(true);
    const response = await getInterview(id);
    this.setLoader(false);
    if (
      (response.status === 200 || response.status === 201) &&
      response?.body?.success
    ) {
      console.log("interview details--", response?.body?.data);
      this.setJobPostApplicant(response?.body?.data);
      return true;
    } else {
      console.log("something went wrong fetching interview details");
      return false;
    }
  }

  async ChangeApplicantStatus(status, statusNumber, isMailSent = true) {
    this.setShowLoader(true);
    const applicantId = localStorage.getItem("applicantId");
    console.log(applicantId);
    const body = {
      isShortlisted: status,
      isHired: false,
      status: statusNumber,
    };

    const response = await changeApplicationStatus(applicantId, body);
    this.setShowLoader(false);
    if (response.status === 200) {
      console.log("applicant status changed", response?.body?.data);
      const data = response?.body?.data;
      if (this.jobPostApplicant) {
        this.jobPostApplicant.isShortlisted = data?.isShortlisted;
        this.jobPostApplicant.isRejected = data?.isRejected;
        this.jobPostApplicant.isHired = data?.isHired;
        this.jobPostApplicant.status = data?.status;
      }
      const index = this.jobPostApplications.findIndex(
        (applicant) => applicant?._id === applicantId,
      );
      if (index !== -1) {
        this.jobPostApplications[index].isShortlisted = data?.isShortlisted;
        this.jobPostApplications[index].isRejected = data?.isRejected;
        this.jobPostApplications[index].isHired = data?.isHired;
        this.jobPostApplications[index].status = data?.status;
      }

      // Sync InterviewApplicants (used in sidebar)
      const interviewIndex = this.InterviewApplicants.findIndex(
        (applicant) => applicant?._id === applicantId,
      );
      if (interviewIndex !== -1) {
        this.InterviewApplicants[interviewIndex].isShortlisted =
          data?.isShortlisted;
        this.InterviewApplicants[interviewIndex].isRejected = data?.isRejected;
        this.InterviewApplicants[interviewIndex].isHired = data?.isHired;
        this.InterviewApplicants[interviewIndex].status = data?.status;
      }

      // Sync allApplicants
      const allIndex = this.allApplicants.findIndex(
        (applicant) => applicant?._id === applicantId,
      );
      if (allIndex !== -1) {
        this.allApplicants[allIndex].isShortlisted = data?.isShortlisted;
        this.allApplicants[allIndex].isRejected = data?.isRejected;
        this.allApplicants[allIndex].isHired = data?.isHired;
        this.allApplicants[allIndex].status = data?.status;
      }

      return true;
    } else {
      return console.log("something went wrong");
    }
  }
  async HireApplicant(status, statusNumber, isMailSent = true) {
    this.setShowLoader(true);
    const applicantId = localStorage.getItem("applicantId");
    console.log(applicantId);
    const body = {
      isHired: status,
      status: statusNumber,
    };
    const response = await changeApplicationStatus(applicantId, body);
    this.setShowLoader(false);
    if (response.status === 200) {
      console.log("applicant status changed", response?.body?.data);
      const data = response?.body?.data;
      if (this.jobPostApplicant) {
        this.jobPostApplicant.isShortlisted = data?.isShortlisted;
        this.jobPostApplicant.isRejected = data?.isRejected;
        this.jobPostApplicant.isHired = data?.isHired;
        this.jobPostApplicant.status = data?.status;
      }
      const index = this.jobPostApplications.findIndex(
        (applicant) => applicant?._id === applicantId,
      );
      if (index !== -1) {
        this.jobPostApplications[index].isShortlisted = data?.isShortlisted;
        this.jobPostApplications[index].isRejected = data?.isRejected;
        this.jobPostApplications[index].isHired = data?.isHired;
        this.jobPostApplications[index].status = data?.status;
      }

      // Sync InterviewApplicants (used in sidebar)
      const interviewIndex = this.InterviewApplicants.findIndex(
        (applicant) => applicant?._id === applicantId,
      );
      if (interviewIndex !== -1) {
        this.InterviewApplicants[interviewIndex].isShortlisted =
          data?.isShortlisted;
        this.InterviewApplicants[interviewIndex].isRejected = data?.isRejected;
        this.InterviewApplicants[interviewIndex].isHired = data?.isHired;
        this.InterviewApplicants[interviewIndex].status = data?.status;
      }

      // Sync allApplicants
      const allIndex = this.allApplicants.findIndex(
        (applicant) => applicant?._id === applicantId,
      );
      if (allIndex !== -1) {
        this.allApplicants[allIndex].isShortlisted = data?.isShortlisted;
        this.allApplicants[allIndex].isRejected = data?.isRejected;
        this.allApplicants[allIndex].isHired = data?.isHired;
        this.allApplicants[allIndex].status = data?.status;
      }

      return true;
    } else {
      return console.log("something went wrong");
    }
  }

  async deleteMockTest(id) {
    this.setLoader(true);
    const response = await deleteMockTestApi(id);
    this.setLoader(false);
    if (response.status === 200 || response.status === 201) {
      console.log("job post deleted", response?.body?.data);
      this.refreshData();
      return true;
    } else {
      return console.log("something went wrong");
    }
  }

  async deleteJobPost(id) {
    this.setLoader(true);
    const response = await deleteJobPost(id);
    this.setLoader(false);
    this.refreshData();
    if (response.status === 200) {
      console.log("job post deleted", response?.body?.data);
      const index = this.jobPosts.findIndex((post) => post?._id === id);
      this.jobPosts.splice(index, 1);

      return true;
    } else {
      return console.log("something went wrong");
    }
  }

  refreshData() {
    this.fetchAllInvitations(true);
    this.fetchCompanyInvitations(true);
    this.fetchJobPostsForHistory(true);
  }

  async deleteInterview(id) {
    this.setLoader(true);
    const response = await deleteInterviewApi(id);
    this.setLoader(false);
    if (response.status === 200 || response.status === 201) {
      console.log("interview deleted", response?.body?.data);
      const index = this.companyInvitations.findIndex(
        (invitation) => invitation?._id === id,
      );
      this.companyInvitations.splice(index, 1);
      this.refreshData();
      return true;
    } else {
      return console.log("something went wrong");
    }
  }
  async deleteResume(id) {
    this.setLoader(true);
    const response = await apiDelete(`/jds/delete-jd/${id}`);
    this.refreshData();
    this.setLoader(false);
    if (response.status === 200) {
      console.log("resume deleted", response?.body?.data);

      return true;
    } else {
      return console.log("something went wrong");
    }
  }

  setApplicantInterviews(interviews) {
    this.applicantInterviews = interviews;
  }

  setCompanyInvitations(interviews) {
    this.companyInvitations = interviews;
  }
  getApplicantsForMockTest = async (id) => {
    this.setLoader(true);
    const response = await getMockTestApplicants(id, {
      skip: this.applicantskip,
      limit: this.applicantlimit,
      clientId: this.clientId,
    });
    runInAction(() => {
      this.setLoader(false);
      if (
        (response.status === 200 || response.status === 201) &&
        response?.body?.success
      ) {
        const data = response.body.data;
        this.InterviewApplicants =
          data?.interviews ??
          data?.mockTestInvites ??
          (Array.isArray(data) ? data : []);
        this.applicantcount =
          response.body?.count ??
          data?.count ??
          (Array.isArray(this.InterviewApplicants)
            ? this.InterviewApplicants.length
            : 0);
      } else {
        this.setLoader(false);
      }
    });
    return response;
  };

  getApplicantsForInterview = async (id, clientId) => {
    if (!id) {
      id = localStorage.getItem("interviewId");
    }
    if (!id) {
      console.warn(
        "getApplicantsForInterview: no interview ID available, skipping request",
      );
      return { status: 400, body: { success: false } };
    }
    this.setLoader(true);
    const response = await getInterviewApplicants(id, {
      skip: this.applicantskip,
      limit: this.applicantlimit,
      clientId: this.clientId || clientId,
    });
    runInAction(() => {
      this.setLoader(false);
      if (
        (response.status === 200 || response.status === 201) &&
        response?.body?.success
      ) {
        const data = response.body.data;
        this.InterviewApplicants =
          data?.interviews ?? (Array.isArray(data) ? data : []);
        this.applicantcount =
          response.body?.count ??
          data?.count ??
          (Array.isArray(this.InterviewApplicants)
            ? this.InterviewApplicants.length
            : 0);
      }
    });
    return response;
  };

  setFilteredApplicants = (applicants) => {
    this.filteredApplicants = applicants;
  };

  /* ------------------------- TO SHOW ALL APPLICANTS ------------------------- */

  setallApplicants = (interviews) => {
    this.allApplicants = interviews;
    this.setFilteredApplicants(interviews);
  };

  /* ---------- SEARCH FUNCTIONALITY FOR APPLICANTS IN INTERVIEW PAGE --------- */

  searchApplicationByNameOrTechnology = async () => {
    let search = this.search;
    // search in the allApplicants with name or technology
    const filteredApplicants = this.allApplicants.filter(
      (applicant) =>
        applicant?.interviewee?.name
          ?.toLowerCase()
          .includes(search.toLowerCase()) ||
        applicant?.technology?.toLowerCase().includes(search.toLowerCase()) ||
        applicant?.role?.toLowerCase().includes(search.toLowerCase()),
    );
    this.setFilteredApplicants(filteredApplicants);
  };

  /* -------------------- GET ALL APPLICATIONS FROM SERVER -------------------- */
  getallApplicantsData = async (refresh = false) => {
    if (this.hittedApis.allApplicants && !refresh) {
      return;
    }
    this.hittedApis.allApplicants = true;
    const user = this.getCurrentUser();
    if (!user) return;
    this.setLoader(true);
    const response = await apiGet(
      `/interview/company/${user?._id}?clientId=${this.clientId}`,
    );
    this.setLoader(false);
    if (response.status === 200) {
      this.setallApplicants(response?.body?.data);
      console.log("thi is response thi is response ", response?.body?.data);
      this.hittedApis.allApplicants = true;
      return response?.body?.data;
    }
    this.hittedApis.allApplicants = false;
  };

  showAllApplicants = () => {
    this.setFilteredApplicants(this.allApplicants);
    this.selectedInvitationId = null;
  };

  filterApplicantsByInvitationId = (invitationId) => {
    this.selectedInvitationId = invitationId;
    const filteredApplicants = this.allApplicants.filter(
      (applicant) => applicant?.invitationFrom === invitationId,
    );
    this.setFilteredApplicants(filteredApplicants);
  };

  async loadPrevUsers() {
    if (this.currentPage === 1) return;
    this.filteredUsers = this.Users.slice(0, this.Users.length - this.limit);
    this.currentPage--;
  }

  async getUsersFromServer() {
    if (this.Users.length > 0) return;
    this.setLoader(true);
    const response = await apiPostPut(
      {},
      `/recruiter/get-candidates-with-filter`,
      "POST",
    );
    this.setLoader(false);
    if (response.status === 200) {
      this.setUsers(response?.body?.data);
      this.filteredUsers = response?.body?.data;
      this.totalPage = response?.body?.count / 10;
      this.totalProfiles = response?.body?.count;
      return true;
    } else {
      alert(response?.body?.message);
      return false;
    }
  }

  async searchOrLoadMoreUsersFromServer() {
    const body = {
      limit: this.limit,
      skip: this.Users.length,
    };
    if (this.search !== null && this.search !== undefined) {
      body.search = this.search;
    }
    if (this.city !== null && this.city !== undefined) {
      body.city = this.city;
    }
    if (this.LookingFor !== null && this.LookingFor !== undefined) {
      body.lookingFor = this.LookingFor;
    }
    this.setLoader(true);
    const response = await apiPostPut(
      body,
      // `/recruiter/get-candidates-with-city`,
      `/recruiter/get-candidates-with-filter`,

      "POST",
    );
    this.setLoader(false);
    if (response.status === 200) {
      this.setUsers([...this.Users, ...response?.body?.data]);
      // this.totalPage = Math.ceil(response?.body?.total / this.limit);
      this.totalPage = response?.body?.count / 10;
      this.filteredUsers = response?.body?.data;
      return true;
    }
  }

  /* ----------------------------- JOB POST ---------------------------- */

  async createJobPost() {
    const userDetails = this.getCurrentUser();
    console.log("userDetails", toJS(userDetails));
    if (!userDetails?._id) return false;

    const mcqData = this.jobPostDetails.mcqTestDetails.skipped
      ? null
      : {
          mockTestName: this.jobPostDetails.mcqTestDetails.testName,
          ...(this.jobPostDetails.mcqTestDetails.cutOff
            ? { cutOff: this.jobPostDetails.mcqTestDetails.cutOff }
            : {}),
          noOfTechnicalQuestions: Number(
            this.jobPostDetails.mcqTestDetails.sections[1].questions,
          ),
          noOfReasoningQuestions: Number(
            this.jobPostDetails.mcqTestDetails.sections[2].questions,
          ),
          noOfVerbalQuestions: Number(
            this.jobPostDetails.mcqTestDetails.sections[3].questions,
          ),
          noOfAptitudeQuestions: Number(
            this.jobPostDetails.mcqTestDetails.sections[0].questions,
          ),
          isDeleted: this.jobPostDetails.mcqTestDetails.skipped,
          customSettings: [
            ...new Map(
              this.jobPostDetails.customSettings.map((setting) => [
                setting.name,
                setting,
              ]),
            ).values(),
          ],
        };

    const technicalData = this.jobPostDetails.technicalInterviewDetails.skipped
      ? null
      : {
          interviewType: "real",
          technology: this.jobPostDetails.technicalInterviewDetails.technology,
          whoPay: this.jobPostDetails.customSettings?.find(
            (setting) => setting.name === "candidatePay",
          )?.value
            ? "candidate"
            : "company",
          interviewId:
            this.jobPostDetails.technicalInterviewDetails.interviewId,
          levelOfInterview:
            this.jobPostDetails.technicalInterviewDetails
              ?.technicalInterviewLevel.length === 0
              ? "low"
              : this.jobPostDetails.technicalInterviewDetails
                  ?.technicalInterviewLevel,
          noOfQuestions: Number(
            this.jobPostDetails.technicalInterviewDetails
              .technicalNumberOfQuestions,
          ),
          noOfCustomQuestions: Number(
            this.jobPostDetails.technicalInterviewDetails.noOfCustomQuestions,
          ),
          noOfFollowUps: Number(
            this.jobPostDetails.technicalInterviewDetails.noOfFollowUps,
          ),
          noOfIntroQuestions: Number(
            this.jobPostDetails.technicalInterviewDetails.noOfIntroQuestions,
          ),
          allQuestions: Number(
            this.jobPostDetails.technicalInterviewDetails.allQuestions,
          ),
          customQuestions:
            this.jobPostDetails.technicalInterviewDetails
              .technicalCustomquestions,
          ...(this.jobPostDetails.basicJobDetails.resumeCutoff
            ? { cutOff: this.jobPostDetails.basicJobDetails.resumeCutoff }
            : {}),
          customSettings: [
            // {
            //   name: "video",
            //   value:
            //     this.jobPostDetails.technicalInterviewDetails.additionalSettings
            //       .camera,
            // },
            // {
            //   name: "resume",
            //   value:
            //     this.jobPostDetails.technicalInterviewDetails.additionalSettings
            //       .resume,
            // },
            // {
            //   name: "screen",
            //   value:
            //     this.jobPostDetails.technicalInterviewDetails.additionalSettings
            //       .screen,
            // },
            ...this.jobPostDetails.customSettings,
            {
              name: "attempts",
              value:
                this.jobPostDetails.technicalInterviewDetails.additionalSettings
                  .attempts,
            },
          ],
        };

    const hrData = this.jobPostDetails.hrInterviewDetails.skipped
      ? null
      : {
          interviewType: "real",
          technology: this.jobPostDetails.hrInterviewDetails.technology,
          whoPay: this.jobPostDetails.customSettings.find(
            (setting) => setting.name === "candidatePay",
          )?.value
            ? "candidate"
            : "company",
          interviewId: this.jobPostDetails.hrInterviewDetails.interviewId,
          levelOfInterview:
            this.jobPostDetails.hrInterviewDetails.interviewLevel.length === 0
              ? "low"
              : this.jobPostDetails.hrInterviewDetails.interviewLevel,
          noOfQuestions: Number(
            this.jobPostDetails.hrInterviewDetails.numberOfQuestions,
          ),
          noOfCustomQuestions: Number(
            this.jobPostDetails.hrInterviewDetails.noOfCustomQuestions,
          ),
          noOfFollowUps: Number(
            this.jobPostDetails.hrInterviewDetails.noOfFollowUps,
          ),
          noOfIntroQuestions: Number(
            this.jobPostDetails.hrInterviewDetails.noOfIntroQuestions,
          ),
          allQuestions: Number(
            this.jobPostDetails.hrInterviewDetails.allQuestions,
          ),
          ...(this.jobPostDetails.hrInterviewDetails.resumeCutoff
            ? { cutOff: this.jobPostDetails.hrInterviewDetails.resumeCutoff }
            : {}),
          customQuestions:
            this.jobPostDetails.hrInterviewDetails.customquestions,
          customSettings: [
            // {
            //   name: "video",
            //   value:
            //     this.jobPostDetails.hrInterviewDetails.additionalSettings
            //       .camera,
            // },
            // {
            //   name: "resume",
            //   value:
            //     this.jobPostDetails.hrInterviewDetails.additionalSettings
            //       .resume,
            // },
            // {
            //   name: "screen",
            //   value:
            //     this.jobPostDetails.hrInterviewDetails.additionalSettings
            //       .screen,
            // },
            ...this.jobPostDetails.customSettings,
            {
              name: "attempts",
              value:
                this.jobPostDetails.hrInterviewDetails.additionalSettings
                  .attempts,
            },
          ],
        };

    const body = {
      recruiterId: userDetails?._id,

      // jobType: this.jobPostDetails.basicJobDetails.jobType,
      ...(this.jobPostDetails.basicJobDetails.resumeCutoff
        ? {
            resumeCutoffScore: this.jobPostDetails.basicJobDetails.resumeCutoff,
          }
        : {}),
      jobTitle: this.jobPostDetails.basicJobDetails.jobTitle,
      requiredExperience: {
        minimum: Number(this.jobPostDetails.basicJobDetails.experience[0]),
        maximum: Number(this.jobPostDetails.basicJobDetails.experience[1]),
      },
      workMode: this.jobPostDetails.basicJobDetails.workMode,
      locations: Array.isArray(this.jobPostDetails.basicJobDetails.location)
        ? this.jobPostDetails.basicJobDetails.location
        : this.jobPostDetails.basicJobDetails.location,
      noOfOpenings: Number(this.jobPostDetails.basicJobDetails.openings),
      jobMode: this.jobPostDetails.basicJobDetails.parttime,
      requiredSkills: this.jobPostDetails.basicJobDetails.requiredSkills,
      jobDescription: this.jobPostDetails.basicJobDetails.jobDescription,
      responsibilities: this.jobPostDetails.basicJobDetails.responsibilities,
      mockTest: mcqData,
      technicalInterview: technicalData,
      hrInterview: hrData,
      customSettings: Array.from(
        new Map(
          this.jobPostDetails.customSettings.map((setting) => [
            setting.name,
            setting,
          ]),
        ).values(),
      ),
      roleType: this.jobPostDetails.basicJobDetails.roleType,

      qualification: this.jobPostDetails.basicJobDetails.qualification,
      noticePeriod: this.jobPostDetails.basicJobDetails.noticePeriod,
      prescreeningQuestions:
        this.jobPostDetails.basicJobDetails.prescreeningQuestions,
      otherPlatforms: this.jobPostDetails.basicJobDetails.otherPlatforms,
      isOtherPlatformsEnabled:
        this.jobPostDetails.basicJobDetails.isOtherPlatformsEnabled,
      // companyName: this.jobPostDetails.basicJobDetails.companyName,
      // companyLogo: this.jobPostDetails.basicJobDetails.companyLogo,
      // companyWebsite: this.jobPostDetails.basicJobDetails.companyWebsite,
      // aboutCompany: this.jobPostDetails.basicJobDetails.aboutCompany,
    };
    if (this.jobPostDetails.basicJobDetails.salary.showPayBy === "range") {
      body.salary = {
        isSalaryDisclosed:
          this.jobPostDetails.basicJobDetails.salary.isSalaryDisclosed,
        showPayBy: this.jobPostDetails.basicJobDetails.salary.showPayBy,
        minimum: this.jobPostDetails.basicJobDetails.salary.min,
        maximum: this.jobPostDetails.basicJobDetails.salary.max,
        rate: this.jobPostDetails.basicJobDetails.salary.rate,
        currency: this.jobPostDetails.basicJobDetails.salary.currency,
      };
    }
    if (!this.jobPostDetails.basicJobDetails.salary.isSalaryDisclosed) {
      body.salary = {
        isSalaryDisclosed: false,
      };
    }
    if (!this.jobPostDetails.taskDetails.skipped) {
      const { skipped, ...taskDetailsWithoutSkipped } =
        this.jobPostDetails.taskDetails;
      if (this.jobPostDetails.taskDetails.assessmentType !== "coding") {
        body.assessment = {
          ...taskDetailsWithoutSkipped,
          customSettings: this.jobPostDetails.customSettings,
        };
      } else {
        // For coding interviews, transform questionBank to only include IDs
        const codingInterviewData = {
          ...taskDetailsWithoutSkipped,
          customSettings: this.jobPostDetails.customSettings,
        };

        // Transform questionBank from objects to IDs for API submission
        if (
          codingInterviewData.questionBank &&
          Array.isArray(codingInterviewData.questionBank)
        ) {
          codingInterviewData.questionBank =
            codingInterviewData.questionBank.map((q) =>
              typeof q === "string" ? q : q._id,
            );
        }

        body.codingInterview = codingInterviewData;
      }
      if (this.jobPostDetails.taskDetails.assessmentType === "tasksBundle") {
        const assessmentData = {
          // ...taskDetailsWithoutSkipped,
          assessmentType: taskDetailsWithoutSkipped.assessmentType,
          tasksBank: taskDetailsWithoutSkipped.tasksBank,
          customSettings: this.jobPostDetails.customSettings,
        };

        if (
          assessmentData.tasksBank &&
          Array.isArray(assessmentData.tasksBank)
        ) {
          assessmentData.tasksBank = assessmentData.tasksBank.map(
            (task) => task._id,
          );
        }
        body.assessment = assessmentData;
      }
    } else {
      body.assessment = null;
      body.codingInterview = null;
    }
    if (
      this.jobPostDetails.basicJobDetails.salary.showPayBy === "exactAmount"
    ) {
      body.salary = {
        showPayBy: this.jobPostDetails.basicJobDetails.salary.showPayBy,
        exactAmount: this.jobPostDetails.basicJobDetails.salary.min,
        rate: this.jobPostDetails.basicJobDetails.salary.rate,
        currency: this.jobPostDetails.basicJobDetails.salary.currency,
      };
    }
    console.log("body", body);

    console.log("body", body);
    if (this.clientId) {
      body.client = this.clientId;
    }
    const response = await createJobPost(body);
    if (response.status === 200 && response.body?.success) {
      console.log("job post created", response?.body?.data);
      this.setJobPostId(response?.body?.data?.jobPost?._id);
      // Reset job post data after successful creation
      this.resetJobPostData();
      return true;
    } else {
      console.log("error", response?.body?.message);
      alert(
        response?.body?.message
          ? response?.body?.message
          : "Make sure you have filled all the details.",
      );
      return false;
    }
  }

  async postOnOtherPlatforms(id = null) {
    const body = {
      jobTitle: this.jobPostDetails.basicJobDetails.jobTitle.split(" ")[0],
      jobDescription: this.jobPostDetails.basicJobDetails.jobDescription,
      locations: Array.isArray(this.jobPostDetails.basicJobDetails.location)
        ? this.jobPostDetails.basicJobDetails.location.join(", ")
        : this.jobPostDetails.basicJobDetails.location,
      officeAddress: Array.isArray(this.jobPostDetails.basicJobDetails.location)
        ? this.jobPostDetails.basicJobDetails.location.join(", ")
        : this.jobPostDetails.basicJobDetails.location,
      salary: JSON.stringify(
        this.jobPostDetails.basicJobDetails.salary.min ||
          this.jobPostDetails.basicJobDetails.salary.exactAmount,
      ),
      salary2: JSON.stringify(this.jobPostDetails.basicJobDetails.salary.max),
      noOfOpenings: this.jobPostDetails.basicJobDetails.openings,
    };
    this.setIsRunningAutoPost(true);
    const response = await apiPostPut(
      body,
      "/other-platfarms/post-job-in-other-platfarms",
      "POST",
    );
    if (response.status === 200) {
      console.log("job post created", response?.body?.data);
      this.setIsRunningAutoPost(false);
      return true;
    } else {
      console.log("error", response?.body?.message);
      // alert(
      //   response?.body?.message
      //     ? response?.body?.message
      //     : "Make sure you have filled all the details."
      // );
      this.setIsRunningAutoPost(false);
      return false;
    }
  }

  async updateJobPost(id) {
    const mockId = localStorage.getItem("mockId");
    const techId = localStorage.getItem("techId");
    const hrId = localStorage.getItem("hrId");

    const mcqData = this.jobPostDetails.mcqTestDetails.skipped
      ? null
      : {
          // _id: mockId,
          mockTestName: this.jobPostDetails.mcqTestDetails.testName,
          noOfTechnicalQuestions: Number(
            this.jobPostDetails.mcqTestDetails.sections[1].questions,
          ),
          noOfReasoningQuestions: Number(
            this.jobPostDetails.mcqTestDetails.sections[2].questions,
          ),
          noOfVerbalQuestions: Number(
            this.jobPostDetails.mcqTestDetails.sections[3].questions,
          ),
          noOfAptitudeQuestions: Number(
            this.jobPostDetails.mcqTestDetails.sections[0].questions,
          ),
          isDeleted: this.jobPostDetails.mcqTestDetails.skipped,
          customSettings: this.jobPostDetails.customSettings,
        };
    if (
      this.jobPostDetails.mcqTestDetails.cutOff !== undefined &&
      this.jobPostDetails.mcqTestDetails.cutOff !== null &&
      this.jobPostDetails.mcqTestDetails.cutOff !== "" &&
      this.jobPostDetails.mcqTestDetails.cutOff !== "undefined"
    ) {
      mcqData.cutOff = this.jobPostDetails.mcqTestDetails.cutOff;
    }

    const technicalData = this.jobPostDetails.technicalInterviewDetails.skipped
      ? null
      : {
          // _id: techId,
          interviewType: "real",
          technology: this.jobPostDetails.technicalInterviewDetails.technology,
          whoPay: this.jobPostDetails.customSettings.find(
            (setting) => setting.name === "candidatePay",
          )?.value
            ? "candidate"
            : "company",
          interviewId:
            this.jobPostDetails.technicalInterviewDetails.interviewId,
          levelOfInterview:
            this.jobPostDetails.technicalInterviewDetails
              .technicalInterviewLevel,
          noOfQuestions: Number(
            this.jobPostDetails.technicalInterviewDetails
              .technicalNumberOfQuestions,
          ),
          noOfCustomQuestions: Number(
            this.jobPostDetails.technicalInterviewDetails.noOfCustomQuestions,
          ),
          noOfFollowUps: Number(
            this.jobPostDetails.technicalInterviewDetails.noOfFollowUps,
          ),
          noOfIntroQuestions: Number(
            this.jobPostDetails.technicalInterviewDetails.noOfIntroQuestions,
          ),
          allQuestions: Number(
            this.jobPostDetails.technicalInterviewDetails.allQuestions,
          ),
          cutOff: this.jobPostDetails.technicalInterviewDetails.resumeCutoff,
          customQuestions:
            this.jobPostDetails.technicalInterviewDetails
              .technicalCustomquestions,
          customSettings: [
            // {
            //   name: "video",
            //   value:
            //     this.jobPostDetails.technicalInterviewDetails.additionalSettings
            //       .camera,
            // },
            // {
            //   name: "resume",
            //   value:
            //     this.jobPostDetails.technicalInterviewDetails.additionalSettings
            //       .resume,
            // },
            // {
            //   name: "screen",
            //   value:
            //     this.jobPostDetails.technicalInterviewDetails.additionalSettings
            //       .screen,
            // },
            ...this.jobPostDetails.customSettings,
            {
              name: "attempts",
              value:
                this.jobPostDetails.technicalInterviewDetails.additionalSettings
                  .attempts,
            },
          ],
        };
    // alert(this.jobPostDetails.hrInterviewDetails.whoPayCheck)

    const hrData = this.jobPostDetails.hrInterviewDetails.skipped
      ? null
      : {
          // _id: hrId,
          interviewType: "real",
          technology: this.jobPostDetails?.hrInterviewDetails?.technology,
          whoPay: this.jobPostDetails.customSettings.find(
            (setting) => setting.name === "candidatePay",
          )?.value
            ? "candidate"
            : "company",
          interviewId: this.jobPostDetails.hrInterviewDetails.interviewId,
          levelOfInterview:
            this.jobPostDetails.hrInterviewDetails.interviewLevel,
          noOfQuestions: Number(
            this.jobPostDetails.hrInterviewDetails.numberOfQuestions,
          ),
          noOfIntroQuestions: Number(
            this.jobPostDetails.hrInterviewDetails.noOfIntroQuestions,
          ),
          noOfCustomQuestions: Number(
            this.jobPostDetails.hrInterviewDetails.noOfCustomQuestions,
          ),
          allQuestions: Number(
            this.jobPostDetails.hrInterviewDetails.allQuestions,
          ),
          noOfFollowUps: Number(
            this.jobPostDetails.hrInterviewDetails.noOfFollowUps,
          ),
          cutOff: this.jobPostDetails.hrInterviewDetails.resumeCutoff,
          customQuestions:
            this.jobPostDetails.hrInterviewDetails.customquestions,
          customSettings: [
            // {
            //   name: "video",
            //   value:
            //     this.jobPostDetails.hrInterviewDetails.additionalSettings
            //       .camera,
            // },
            // {
            //   name: "resume",
            //   value:
            //     this.jobPostDetails.hrInterviewDetails.additionalSettings
            //       .resume,
            // },
            // {
            //   name: "screen",
            //   value:
            //     this.jobPostDetails.hrInterviewDetails.additionalSettings
            //       .screen,
            // },
            ...this.jobPostDetails.customSettings,
            {
              name: "attempts",
              value:
                this.jobPostDetails.hrInterviewDetails.additionalSettings
                  .attempts,
            },
          ],
        };

    const jobPostData = {
      _id: id,
      // jobType: this.jobPostDetails.basicJobDetails.jobType,
      // cutoff: this.jobPostDetails.basicJobDetails.resumeCutoff,
      jobTitle: this.jobPostDetails.basicJobDetails.jobTitle,
      customSettings: this.jobPostDetails.customSettings,
      requiredExperience: {
        minimum: Number(this.jobPostDetails.basicJobDetails.experience[0]),
        maximum: Number(this.jobPostDetails.basicJobDetails.experience[1]),
      },
      workMode: this.jobPostDetails.basicJobDetails.workMode,
      locations: Array.isArray(this.jobPostDetails.basicJobDetails.location)
        ? this.jobPostDetails.basicJobDetails.location
        : this.jobPostDetails.basicJobDetails.location,
      noOfOpenings: Number(this.jobPostDetails.basicJobDetails.openings),
      jobMode: this.jobPostDetails.basicJobDetails.parttime,
      salary: {
        isSalaryDisclosed:
          this.jobPostDetails.basicJobDetails.salary.isSalaryDisclosed,
        showPayBy: this.jobPostDetails.basicJobDetails.salary.showPayBy,
        minimum: this.jobPostDetails.basicJobDetails.salary.min,
        maximum: this.jobPostDetails.basicJobDetails.salary.max,
        rate: this.jobPostDetails.basicJobDetails.salary.rate,
        currency: this.jobPostDetails.basicJobDetails.salary.currency,
      },
      requiredSkills: this.jobPostDetails.basicJobDetails.requiredSkills,
      jobDescription: this.jobPostDetails.basicJobDetails.jobDescription,
      responsibilities: this.jobPostDetails.basicJobDetails.responsibilities,
      qualification: this.jobPostDetails.basicJobDetails.qualification,
      noticePeriod: this.jobPostDetails.basicJobDetails.noticePeriod,
      roleType: this.jobPostDetails.basicJobDetails.roleType,
      prescreeningQuestions:
        this.jobPostDetails.basicJobDetails.prescreeningQuestions,
      otherPlatforms: this.jobPostDetails.basicJobDetails.otherPlatforms,
      isOtherPlatformsEnabled:
        this.jobPostDetails.basicJobDetails.isOtherPlatformsEnabled,
      ...(this.jobPostDetails.basicJobDetails.resumeCutoff
        ? {
            resumeCutoffScore: this.jobPostDetails.basicJobDetails.resumeCutoff,
          }
        : {}),
    };

    const body = {
      ...jobPostData,
      mockTest: mcqData,
      technicalInterview: technicalData,
      hrInterview: hrData,
      // recruiterId: JSON.parse(localStorage.getItem("user"))?._id,
    };
    if (!this.jobPostDetails.taskDetails.skipped) {
      const { skipped, _id, ...taskDetailsWithoutSkipped } =
        this.jobPostDetails.taskDetails;
      if (this.jobPostDetails.taskDetails.assessmentType !== "coding") {
        body.assessment = {
          ...taskDetailsWithoutSkipped,
          customSettings: this.jobPostDetails.customSettings,
        };
        body.isAssessmentAdded = true;
      } else {
        // For coding interviews, transform questionBank to only include IDs
        const codingInterviewData = {
          ...taskDetailsWithoutSkipped,
          customSettings: this.jobPostDetails.customSettings,
        };

        // Transform questionBank from objects to IDs for API submission
        if (
          codingInterviewData.questionBank &&
          Array.isArray(codingInterviewData.questionBank)
        ) {
          codingInterviewData.questionBank =
            codingInterviewData.questionBank.map((q) =>
              typeof q === "string" ? q : q._id,
            );
        }

        body.codingInterview = codingInterviewData;
        body.isCodingInterviewAdded = true;
      }
      if (this.jobPostDetails.taskDetails.assessmentType === "tasksBundle") {
        const assessmentData = {
          // ...taskDetailsWithoutSkipped,
          assessmentType: taskDetailsWithoutSkipped.assessmentType,
          tasksBank: taskDetailsWithoutSkipped.tasksBank,
          customSettings: this.jobPostDetails.customSettings,
        };

        if (
          assessmentData.tasksBank &&
          Array.isArray(assessmentData.tasksBank)
        ) {
          assessmentData.tasksBank = assessmentData.tasksBank.map(
            (task) => task._id,
          );
        }
        body.assessment = assessmentData;
      }
    } else {
      // if (this.jobPostDetails.taskDetails.assessmentType !== "coding") {
      body.assessment = null;
      body.isAssessmentAdded = false;
      // } else {
      body.codingInterview = null;
      body.isCodingInterviewAdded = false;
      // }
    }
    if (!this.jobPostDetails.hrInterviewDetails.skipped) {
      body.isHrInterviewAdded = true;
    } else {
      body.isHrInterviewAdded = false;
    }
    if (!this.jobPostDetails.technicalInterviewDetails.skipped) {
      body.isTechInterviewAdded = true;
    } else {
      body.isTechInterviewAdded = false;
    }
    if (!this.jobPostDetails.mcqTestDetails.skipped) {
      body.isMockTestAdded = true;
    } else {
      body.isMockTestAdded = false;
    }
    console.log("body", body);
    // return;
    const response = await updateJobPostApi(id, body);
    this.jobPostDetails.technicalInterviewDetails.whoPayCheck = false;
    this.jobPostDetails.hrInterviewDetails.whoPayCheck = false;
    if (response.status === 200 && response.body?.success) {
      console.log("job post created", response?.body?.data);
      this.setJobPostId(response?.body?.data?._id);
      // Reset job post data after successful update
      this.resetJobPostData();
      return true;
    } else {
      alert("Make sure you have filled all the details.");
      return false;
    }
  }

  // async fetchJobData(jobId) {
  //   // if (!refresh && this.hittedApis[jobId]) return;
  //   // this.loading = true;
  //   const user = JSON.parse(localStorage.getItem("user"));
  //   console.log(user)
  //   const  response = await apiGet(`/job-post/job-post/${jobId}`);
  //   if (response.status === 200) {
  //     console.log("JobData", response?.body?.data);
  //     return this.setJobData(response?.body?.data);
  //   } else {
  //     return alert("Failed to fetch data");
  //   }
  // }
  // setJobData(jobData) {
  //   this.JobData = jobData;
  // }

  // async fetchJobPosts() {
  // fetching the all job posts in student career portal

  async fetchJobPosts(body) {
    // fetching the all job posts in student career portal
    this.loader = true;

    const user = this.getCurrentUser();
    console.log(user, "this is the user");

    const response = await apiPostPut(
      {
        userSkills: user?.skills,
        userExperience: user?.previousCompanies
          .reduce((acc, company) => {
            const startDate = new Date(company.joiningDate);
            const endDate = new Date(company.completionDate);
            const diffTime = Math.abs(endDate - startDate);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            // Convert days to years (approximate: 365 days in a year)
            const diffYears = diffDays / 365;

            // Accumulate the total years
            return acc + diffYears;
          }, 0)
          .toFixed(2),
      },

      `/job-post/job-posts?skip=${body.skip}&limit=${body.limit}`,
      "POST",
    ); //after testing change to ${'user'._id}
    if (response.status === 200) {
      console.log("JobData", response?.body?.data);
      this.jobpostcount = response?.body?.count;
      this.setJobPosts(response?.body?.data);
      console.log("JobData565", toJS(this.jobpostcount));
      this.setLoader(false);
    } else {
      this.loader = false;
      return alert("Failed to fetch data");
    }
  }

  async fetchJobApplications(body) {
    this.setLoader(true);
    const userId = this.getCurrentUserId();
    if (!userId) {
      this.setLoader(false);
      return false;
    }
    const response = await apiGet(
      `/application/applications?userId=${userId}&skip=${body?.skip}&limit=${
        body?.limit
      }&clientId=${this.clientId}&searchFilter=${
        body?.search ? body?.search : null
      }`,
    );
    this.setLoader(false);
    if (response.status === 200) {
      console.log("JobApplications", response?.body?.data);
      this.applicationCount = response?.body?.count;
      this.setJobApplications(response?.body?.data);
      localStorage.setItem("job", JSON.stringify(response?.body?.data));
    } else {
      return alert("Failed to fetch data");
    }
  }

  async autoGenerate(responsibilites) {
    const tokens = responsibilites ? 300 : 1000;
    console.log(toJS(this.jobPostDetails.basicJobDetails));
    this.setLoader(true);

    // Enhanced responsibility prompt with more details
    const responsibilityPrompt = `List the key responsibilities for a ${
      this.jobPostDetails.basicJobDetails.jobTitle
    } position requiring ${
      this.jobPostDetails.basicJobDetails.experience[0]
    } to ${
      this.jobPostDetails.basicJobDetails.experience[1]
    } years of experience. This is a ${
      this.jobPostDetails.basicJobDetails.workMode
    } role located in ${
      Array.isArray(this.jobPostDetails.basicJobDetails.location)
        ? this.jobPostDetails.basicJobDetails.location.join(", ")
        : this.jobPostDetails.basicJobDetails.location
    } with ${
      this.jobPostDetails.basicJobDetails.openings
    } openings available. The annual salary package ranges from ${
      this.jobPostDetails.basicJobDetails.salary.min
    }  ${
      this.jobPostDetails.basicJobDetails.salary.max &&
      !(this.jobPostDetails.basicJobDetails.salary.showPayBy === "exactAmount")
        ? `to ${this.jobPostDetails.basicJobDetails.salary.max}`
        : ""
    } ${this.jobPostDetails?.basicJobDetails?.salary?.rate} . This is a ${
      this.jobPostDetails.basicJobDetails.parttime
    } position. The ideal candidate should have skills in ${
      this.jobPostDetails.basicJobDetails.requiredSkills
    }. Generate response under ${tokens} tokens`;

    // Enhanced job description prompt with comprehensive details
    const jobDescriptionPrompt = `Generate a detailed, well-structured job description in HTML format for the following position. Do not include any HTML tags, code blocks, or formatting markers at the start of the response - begin directly with the job description content:

**Job Details:**
- Job Title: ${this.jobPostDetails.basicJobDetails.jobTitle}
- Experience Required: ${
      this.jobPostDetails.basicJobDetails.experience[0]
    } to ${this.jobPostDetails.basicJobDetails.experience[1]} years
- Work Mode: ${this.jobPostDetails.basicJobDetails.workMode}
- Location: ${
      Array.isArray(this.jobPostDetails.basicJobDetails.location)
        ? this.jobPostDetails.basicJobDetails.location.join(", ")
        : this.jobPostDetails.basicJobDetails.location
    }
- Number of Openings: ${this.jobPostDetails.basicJobDetails.openings}
- Employment Type: ${this.jobPostDetails.basicJobDetails.parttime}
- Notice Period: ${
      this.jobPostDetails.basicJobDetails.noticePeriod || "Not specified"
    }
- Role Type: ${this.jobPostDetails.basicJobDetails.roleType}

**Compensation:**
-Paid: ${
      this.jobPostDetails.basicJobDetails.salary.isSalaryDisclosed
        ? "Yes"
        : "No"
    }
- Salary Range: ${this.jobPostDetails.basicJobDetails.salary.min}${
      this.jobPostDetails.basicJobDetails.salary.max &&
      !(this.jobPostDetails.basicJobDetails.salary.showPayBy === "exactAmount")
        ? ` to ${this.jobPostDetails.basicJobDetails.salary.max}`
        : ""
    } ${this.jobPostDetails?.basicJobDetails?.salary?.rate}
- Currency: ${
      this.jobPostDetails?.basicJobDetails?.salary?.currency || "Not specified"
    }
- Pay Display: ${this.jobPostDetails.basicJobDetails.salary.showPayBy}

**Required Skills & Qualifications:**
- Required Skills: ${this.jobPostDetails.basicJobDetails.requiredSkills}
- Qualification: ${
      this.jobPostDetails.basicJobDetails.qualification || "Not specified"
    }





Instructions:
- Do NOT include any heading like 'Job Description', 'Job Opening', or the job title at the top.
- Start directly with the job details.
- Structure the description with clear sections, such as:
  - About the Role
  - Key Responsibilities (as a bullet list)
  - Required Skills & Qualifications (as a bullet list)
  - Benefits & Perks (if information is available)
  - About the Company (if company information is available)
  - Application Process (mentioning the assessment process if applicable)
- Use proper HTML tags for formatting: <h3>, <h4>, <ul>, <li>, <b>, <br />, etc.
- Write in clear, concise, and engaging language suitable for job seekers.
- Do NOT repeat the job title or add any heading at the top, as it will be added separately.

- Limit the response to ${tokens} tokens.`;

    const body = {
      prompt: responsibilites ? responsibilityPrompt : jobDescriptionPrompt,
      model: 1,
      max_tokens: tokens,
      stop: null,
    };

    const response = await postJobAiChat(body);
    this.setLoader(false);
    if (response.status === 200 && response.body?.success) {
      console.log("ai-chat", response?.body?.data?.body?.content);
      if (responsibilites) {
        return (this.jobPostDetails.basicJobDetails.responsibilities =
          response?.body?.data?.body?.content);
      }
      return (this.jobPostDetails.basicJobDetails.jobDescription =
        response?.body?.data?.body?.content);
    } else {
      return alert("Failed to generate");
    }
  }

  async autoGenerateJD() {
    this.generaterLoader = true;
    const body = {
      prompt: `Generate a job description for a ${this.generateParams.title} position requiring ${this.generateParams.minexp} to ${this.generateParams.maxexp} years of experience. This is a ${this.generateParams.mode} role  with ${this.generateParams.qualification} qualification  and ${this.generateParams.salary} salary paid.   The ideal candidate should have skills in ${this.generateParams.skills}. Provide me in the paragraph`,
      model: 1,
      max_tokens: 300,
      stop: null,
    };
    const response = await postJobAiChat(body);
    this.generaterLoader = false;
    if (response.status === 200 && response.body?.success) {
      console.log("ai-chat", response?.body?.data?.body?.content);

      return (this.generatedJD = response?.body?.data?.body?.content);
    } else {
      return alert("Failed to generate");
    }
  }

  async fetchJobPostDetails(id) {
    this.setLoader(true);
    const queryParams = this.clientId ? { clientId: this.clientId } : undefined;
    const response = await getJobPost(id, queryParams);
    this.setLoader(false);
    if (response.status === 200 && response.body?.success) {
      const data = response?.body?.data;
      console.log(response?.body?.data, "this is the data");
      localStorage.setItem("mockId", data?.mockTest?._id);
      localStorage.setItem("techId", data?.technicalInterview?._id);
      localStorage.setItem("hrId", data?.hrInterview?._id);
      const basicDetails = {
        requiredSkills: data?.requiredSkills,
      };

      // this.autofillJobPostDetails(basicDetails);

      this.setBasicJobDetails("jobType", data?.jobType);
      this.setBasicJobDetails("jobTitle", data?.jobTitle);
      this.setBasicJobDetails("experience", [
        data?.requiredExperience?.minimum,
        data?.requiredExperience?.maximum,
      ]);
      // Map job post level customSettings first
      if (data?.customSettings && Array.isArray(data.customSettings)) {
        data.customSettings.map((setting) => {
          this.setJobPostCustomSettings(setting.name, setting.value);
        });
      }
      // Map technical interview customSettings
      if (
        data?.technicalInterview?.customSettings &&
        Array.isArray(data.technicalInterview.customSettings)
      ) {
        data.technicalInterview.customSettings.map((setting) => {
          this.setJobPostCustomSettings(setting.name, setting.value);
        });
      }
      // Map HR interview customSettings
      if (
        data?.hrInterview?.customSettings &&
        Array.isArray(data.hrInterview.customSettings)
      ) {
        data.hrInterview.customSettings.map((setting) => {
          this.setJobPostCustomSettings(setting.name, setting.value);
        });
      }
      // Ensure restrictAssessments exists (for backward compatibility)
      const restrictAssessmentsExists = this.jobPostDetails.customSettings.find(
        (setting) => setting.name === "restrictAssessments",
      );
      if (!restrictAssessmentsExists) {
        this.setJobPostCustomSettings("restrictAssessments", false);
      }
      this.setBasicJobDetails("workMode", data?.workMode);
      data?.locations.length > 0
        ? this.setBasicJobDetails("location", [...data?.locations])
        : this.setBasicJobDetails("location", [data?.jobLocation]);
      this.setBasicJobDetails("openings", data?.noOfOpenings);
      this.setBasicJobDetails("qualification", data?.qualification);
      this.setBasicJobDetails("otherPlatforms", data?.otherPlatforms);
      this.setBasicJobDetails(
        "isOtherPlatformsEnabled",
        data?.isOtherPlatformsEnabled,
      );
      this.setBasicJobDetails("noticePeriod", data?.noticePeriod);
      this.setBasicJobDetails("parttime", data?.jobMode);
      this.setBasicJobDetails("roleType", data?.roleType);
      if (data?.salary?.isSalaryDisclosed) {
        this.jobPostDetails.basicJobDetails.salary.isSalaryDisclosed = true;
        this.jobPostDetails.basicJobDetails.salary.showPayBy =
          data?.salary?.showPayBy;
        if (data?.salary?.showPayBy === "range") {
          this.jobPostDetails.basicJobDetails.salary.min =
            data?.salary?.minimum;
          this.jobPostDetails.basicJobDetails.salary.max =
            data?.salary?.maximum;
        }
        if (data?.salary?.showPayBy === "exactAmount") {
          this.jobPostDetails.basicJobDetails.salary.min =
            data?.salary?.exactAmount || data?.salary?.minimum;
        }
        this.jobPostDetails.basicJobDetails.salary.rate = data?.salary?.rate;
        this.jobPostDetails.basicJobDetails.salary.currency =
          data?.salary?.currency;
      } else {
        this.jobPostDetails.basicJobDetails.salary = {
          isSalaryDisclosed: false,
        };
      }

      // this.setBasicJobDetails("salary", [
      //   data?.salary?.minimum ?? data?.salary?.exactAmount,
      //   data?.salary?.maximum,
      //   data?.salary?.rate,
      //   data?.salary?.showPayBy,
      // ]);
      // console.log(this.jobPostDetails.basicJobDetails.salary,"meghana");
      this.setBasicJobDetails("requiredSkills", data?.requiredSkills);
      console.log(toJS(this.jobPostDetails.basicJobDetails.requiredSkills));
      this.setBasicJobDetails("jobDescription", data?.jobDescription);
      this.setBasicJobDetails(
        "prescreeningQuestions",
        data?.prescreeningQuestions,
      );
      this.setBasicJobDetails("responsibilities", data?.responsibilities);
      this.setMcqTestDetails(
        "testName",
        data?.mockTest === null ? "" : data?.mockTest?.mockTestName,
      );
      this.setMcqTestDetails(
        "numberOfQuestions",
        data?.mockTest === null
          ? ""
          : Number(data?.mockTest?.noOfAptitudeQuestions) +
              Number(data?.mockTest?.noOfReasoningQuestions) +
              Number(data?.mockTest?.noOfTechnicalQuestions) +
              Number(data?.mockTest?.noOfVerbalQuestions),
      );
      this.setMcqTestDetails(
        "cutOff",
        data?.mockTest === null ? "" : `${data?.mockTest?.cutOff}`,
      );
      this.setMcqSections(
        "questions",
        0,
        data?.mockTest === null
          ? 0
          : Number(data?.mockTest?.noOfAptitudeQuestions),
      );
      this.setMcqSections(
        "questions",
        1,
        data?.mockTest === null
          ? 0
          : Number(data?.mockTest?.noOfTechnicalQuestions),
      );
      this.setMcqSections(
        "questions",
        2,
        data?.mockTest === null
          ? 0
          : Number(data?.mockTest?.noOfReasoningQuestions),
      );
      this.setMcqSections(
        "questions",
        3,
        data?.mockTest === null
          ? 0
          : Number(data?.mockTest?.noOfVerbalQuestions),
      );
      this.setMcqTestDetails("skipped", data?.mockTest === null ? true : false);
      if (!data?.mockTest) {
        this.setMcqTestDetails("skipped", true);
      }

      this.commonStore.setLabelActive(
        1,
        data?.mockTest === null ? false : true,
      );

      this.commonStore.setLabelActive(
        2,
        data?.technicalInterview === null ? false : true,
      );

      this.commonStore.setLabelActive(
        3,
        data?.hrInterview === null ? false : true,
      );

      this.commonStore.setLabelActive(
        5,
        data?.assessment && data?.codingInterview === null ? false : true,
      );

      console.log(data?.technicalInterview?.interviewId);
      console.log(data?.technicalInterview?.technology);
      this.setTechnicalInterviewDetails(
        "allQuestions",
        data?.technicalInterview?.allQuestions,
      );

      this.setTechnicalInterviewDetails(
        "technicalInterviewType",
        data?.technicalInterview === null
          ? "AI interview"
          : data?.technicalInterview?.interviewId === 2
            ? "AI interview"
            : "Manual interview",
      );
      this.setTechnicalInterviewDetails(
        "technology",
        data?.technicalInterview === null
          ? ""
          : data?.technicalInterview?.technology,
      );
      this.setTechnicalInterviewDetails(
        "interviewId",
        data?.technicalInterview === null
          ? ""
          : data?.technicalInterview?.interviewId,
      );
      this.setTechnicalInterviewDetails(
        "technicalInterviewLevel",
        data?.technicalInterview === null
          ? "low"
          : data?.technicalInterview?.levelOfInterview,
      );
      this.setTechnicalInterviewDetails(
        "technicalNumberOfQuestions",
        data?.technicalInterview === null
          ? null
          : data?.technicalInterview?.noOfQuestions,
      );
      this.setTechnicalInterviewDetails(
        "noOfIntroQuestions",
        data?.technicalInterview === null
          ? null
          : data?.technicalInterview?.noOfIntroQuestions,
      );

      this.setTechnicalInterviewDetails(
        "noOfCustomQuestions",
        data?.technicalInterview === null
          ? null
          : data?.technicalInterview?.noOfCustomQuestions,
      );
      this.setTechnicalInterviewDetails(
        "noOfFollowUps",
        data?.technicalInterview === null
          ? null
          : data?.technicalInterview?.noOfFollowUps,
      );
      this.setTechnicalInterviewDetails(
        "technicalCustomquestions",
        data?.technicalInterview === null
          ? []
          : data?.technicalInterview?.customQuestions,
      );
      this.settechnicalAdditionalSettings(
        "camera",
        data?.technicalInterview === null
          ? false
          : data?.technicalInterview?.customSettings[0]?.value,
      );
      this.settechnicalAdditionalSettings(
        "screen",
        data?.technicalInterview === null
          ? false
          : data?.technicalInterview?.customSettings[2]?.value,
      );
      this.settechnicalAdditionalSettings(
        "resume",
        data?.technicalInterview === null
          ? false
          : data?.technicalInterview?.customSettings[1]?.value,
      );
      this.settechnicalAdditionalSettings(
        "attempts",
        data?.technicalInterview === null
          ? 1
          : data?.technicalInterview?.customSettings.find(
              (setting) => setting.name === "attempts",
            )?.value,
      );
      this.setTechnicalInterviewDetails(
        "skipped",
        data?.technicalInterview === null ? true : false,
      );
      if (!data?.technicalInterview) {
        this.setTechnicalInterviewDetails("skipped", true);
      }

      this.setHrInterviewDetails(
        "interviewType",
        data?.hrInterview === null
          ? "AI HR interview"
          : data?.hrInterview?.interviewId === 8
            ? "AI HR interview"
            : "Manual HR interview",
      );
      this.setHrInterviewDetails(
        "technology",
        data?.hrInterview === null ? "" : data?.hrInterview?.technology,
      );
      this.setHrInterviewDetails(
        "interviewId",
        data?.hrInterview === null ? "" : data?.hrInterview?.interviewId,
      );
      this.setHrInterviewDetails(
        "interviewLevel",
        data?.hrInterview === null
          ? "low"
          : data?.hrInterview?.levelOfInterview,
      );
      this.setHrInterviewDetails(
        "numberOfQuestions",
        data?.hrInterview === null ? "" : data?.hrInterview?.noOfQuestions,
      );
      this.setHrInterviewDetails(
        "noOfIntroQuestions",
        data?.hrInterview === null ? "" : data?.hrInterview?.noOfIntroQuestions,
      );
      this.setHrInterviewDetails(
        "allQuestions",
        data?.hrInterview === null ? "" : data?.hrInterview?.allQuestions,
      );
      this.setHrInterviewDetails(
        "noOfCustomQuestions",
        data?.hrInterview === null
          ? ""
          : data?.hrInterview?.noOfCustomQuestions,
      );
      this.setHrInterviewDetails(
        "noOfFollowUps",
        data?.hrInterview === null ? "" : data?.hrInterview?.noOfFollowUps,
      );
      this.setHrInterviewDetails(
        "customquestions",
        data?.hrInterview === null ? [] : data?.hrInterview?.customQuestions,
      );
      this.sethrAdditionalSettings(
        "camera",
        data?.hrInterview === null
          ? false
          : data?.hrInterview?.customSettings[0]?.value,
      );
      this.sethrAdditionalSettings(
        "screen",
        data?.hrInterview === null
          ? false
          : data?.hrInterview?.customSettings[2]?.value,
      );
      this.sethrAdditionalSettings(
        "resume",
        data?.hrInterview === null
          ? false
          : data?.hrInterview?.customSettings[1]?.value,
      );
      this.sethrAdditionalSettings(
        "attempts",
        data?.hrInterview === null
          ? 1
          : data?.hrInterview?.customSettings.find(
              (setting) => setting.name === "attempts",
            )?.value,
      );
      this.sethrAdditionalSettings(
        "skipped",
        data?.hrInterview === null ? true : false,
      );
      if (!data?.hrInterview) {
        this.setHrInterviewDetails("skipped", true);
      }
      this.jobPostDetails.technicalInterviewDetails.whoPayCheck =
        data?.technicalInterview?.whoPay !== "company" ? true : false;
      this.jobPostDetails.hrInterviewDetails.whoPayCheck =
        data?.hrInterview?.whoPay !== "company" ? true : false;

      this.jobPostDetails.basicJobDetails.resumeCutoff =
        data?.resumeCutoffScore;
      this.jobPostDetails.technicalInterviewDetails.resumeCutoff =
        data?.technicalInterview?.cutOff;
      this.jobPostDetails.hrInterviewDetails.resumeCutoff =
        data?.hrInterview?.cutOff;
      if (data?.assessment) {
        this.jobPostDetails.taskDetails = {
          ...(this.jobPostDetails.taskDetails || {}),
          ...data?.assessment,
          skipped: false,
        };
        console.log("assessment");
      } else if (data?.codingInterview) {
        console.log(this.jobPostDetails.taskDetails, "codingInterview");
        this.jobPostDetails.taskDetails = {
          ...(this.jobPostDetails.taskDetails || {}),
          ...data?.codingInterview,
          skipped: false,
        };
        this.setTaskDetails("assessmentType", "coding");
        this.setTaskDetails(
          "levelOfInterview",
          data?.codingInterview?.levelOfInterview,
        );
        console.log("codingInterview");
        this.setTaskDetails(
          "questionBank",
          data?.codingInterview?.questionBank,
        );
        console.log(
          toJS(this.jobPostDetails.taskDetails.questionBank),
          "questionBank",
        );
        this.jobPostDetails.taskDetails = {
          ...this.jobPostDetails.taskDetails,
          skipped: false,
        };
        console.log(this.jobPostDetails.taskDetails, "taskDetails");
      } else {
        console.log("else");
        this.jobPostDetails.taskDetails = {
          skipped: true,
        };
      }

      // this.jobPostDetails.basicJobDetails.jobType =
      //   response?.body?.data?.jobType;
      // this.jobPostDetails.basicJobDetails.jobType =
      //   response?.body?.data?.jobType;
      // this.jobPostDetails.basicJobDetails.jobType =
      //   response?.body?.data?.jobType;

      return;
    } else {
      return alert("Failed to fetch");
    }
  }

  setPrescreeningQuestions(questions) {
    this.jobPostDetails.basicJobDetails.prescreeningQuestions = questions;
  }

  setOtherPlatforms(platforms) {
    this.jobPostDetails.basicJobDetails.otherPlatforms = platforms;
  }
  setIsOtherPlatformsEnabled(isEnabled) {
    this.jobPostDetails.basicJobDetails.isOtherPlatformsEnabled = isEnabled;
  }

  customPlatforms = [];

  setCustomPlatforms(platforms) {
    this.customPlatforms = platforms;
  }

  getDefaultJobPostDetails() {
    return {
      jobType: "job",
      jobTitle: "Software Engineer",
      location: ["Bangalore"],
      experience: [1, 3],
      workMode: "workFromOffice",
      openings: 2,
      salary: {
        showPayBy: "range",
        currency: "INR",
        min: "500000",
        max: "1000000",
        rate: "per annum",
      },
      resumeCutoff: "70",
      jobDescription: "<p>Default job description</p>",
      responsibilities: "Default responsibilities",
      requiredSkills: ["React JS", "Node.js"],
      parttime: "full-time",
      qualification: "B.Tech",
      noticePeriod: "30",
      roleType: "technical",
    };
  }

  codingQuestionsBank = [];

  hasUnsavedTasks = false;

  setHasUnsavedTasks(value) {
    this.hasUnsavedTasks = value;
  }

  setCodingQuestionsBank(questions) {
    this.codingQuestionsBank = questions;
  }

  removeCodingQuestionById(id) {
    this.codingQuestionsBank = this.codingQuestionsBank.filter(
      (q) => q._id !== id,
    );
  }

  updateCodingQuestionById(id, updatedQuestion) {
    this.codingQuestionsBank = this.codingQuestionsBank.map((q) =>
      q._id === id ? updatedQuestion : q,
    );
  }

  // Verification System Methods
  verificationData = null;
  verificationLoader = false;

  setVerificationData(data) {
    this.verificationData = data;
  }

  setVerificationLoader(loading) {
    this.verificationLoader = loading;
  }

  // Create verification document
  async createVerification(applicationId, userId, verificationData) {
    this.setVerificationLoader(true);
    try {
      const body = {
        applicationId,
        userId,
        overallStatus: verificationData.overallStatus || 0,
        verifications: verificationData.verifications || [],
        globalNotes: verificationData.globalNotes || [],
      };

      const response = await createVerificationApi(body);

      this.setVerificationLoader(false);
      if (response.status === 200 || response.status === 201) {
        this.setVerificationData(response.body.data);
        return { success: true, data: response.body.data };
      } else {
        return {
          success: false,
          message: response.body.message || "Failed to create verification",
        };
      }
    } catch (error) {
      this.setVerificationLoader(false);
      return { success: false, message: "Network error occurred" };
    }
  }

  // Get verification by application and user
  async getVerificationByApplicationAndUser(applicationId, userId) {
    this.setVerificationLoader(true);
    try {
      const response = await getVerificationByAppAndUserApi(
        applicationId,
        userId,
      );
      this.setVerificationLoader(false);

      if (response.status === 200) {
        this.setVerificationData(response.body.data);
        return { success: true, data: response.body.data };
      } else {
        return {
          success: false,
          message: response.body.message || "Verification not found",
        };
      }
    } catch (error) {
      this.setVerificationLoader(false);
      return { success: false, message: "Network error occurred" };
    }
  }

  // Add new verification type
  async addVerificationType(verificationId, verificationTypeData) {
    this.setVerificationLoader(true);
    try {
      const response = await addVerificationTypeApi(
        verificationId,
        verificationTypeData,
      );

      this.setVerificationLoader(false);
      if (response.status === 200) {
        this.setVerificationData(response.body.data);
        return { success: true, data: response.body.data };
      } else {
        return {
          success: false,
          message: response.body.message || "Failed to add verification type",
        };
      }
    } catch (error) {
      this.setVerificationLoader(false);
      return { success: false, message: "Network error occurred" };
    }
  }

  // Update verification status
  async updateVerificationStatus(
    verificationId,
    verificationType,
    status,
    notes = "",
    rejectionReason = "",
    rejectedBy = null,
  ) {
    this.setVerificationLoader(true);
    try {
      const body = {
        verificationType,
        status,
        notes,
        rejectionReason,
        rejectedBy,
      };

      const response = await updateVerificationStatusApi(verificationId, body);

      this.setVerificationLoader(false);
      if (response.status === 200) {
        this.setVerificationData(response.body.data);
        return { success: true, data: response.body.data };
      } else {
        return {
          success: false,
          message:
            response.body.message || "Failed to update verification status",
        };
      }
    } catch (error) {
      this.setVerificationLoader(false);
      return { success: false, message: "Network error occurred" };
    }
  }

  // Update existing verification document
  async updateVerification(verificationId, documentData) {
    this.setVerificationLoader(true);
    try {
      console.log("Updating verification document:", {
        verificationId,
        documentData,
      });

      const response = await updateVerificationApi(
        verificationId,
        documentData,
      );

      this.setVerificationLoader(false);
      if (response.status === 200) {
        this.setVerificationData(response.body.data);
        return { success: true, data: response.body.data };
      } else {
        console.error("Update verification failed:", response.body);
        return {
          success: false,
          message: response.body.message || "Failed to update verification",
        };
      }
    } catch (error) {
      console.error("Update verification error:", error);
      this.setVerificationLoader(false);
      return { success: false, message: "Network error occurred" };
    }
  }

  // Update specific verification type within a document
  async updateVerificationType(
    verificationId,
    verificationType,
    verificationData,
  ) {
    this.setVerificationLoader(true);
    try {
      const body = {
        verificationType,
        ...verificationData,
      };

      const response = await updateVerificationApi(verificationId, body);

      this.setVerificationLoader(false);
      if (response.status === 200) {
        this.setVerificationData(response.body.data);
        return { success: true, data: response.body.data };
      } else {
        return {
          success: false,
          message:
            response.body.message || "Failed to update verification type",
        };
      }
    } catch (error) {
      this.setVerificationLoader(false);
      return { success: false, message: "Network error occurred" };
    }
  }

  // Add proof documents
  async addProofDocuments(verificationId, verificationType, proofDocuments) {
    this.setVerificationLoader(true);
    try {
      const body = {
        verificationType,
        proof: proofDocuments,
      };

      const response = await addProofDocumentsApi(verificationId, body);

      this.setVerificationLoader(false);
      if (response.status === 200) {
        this.setVerificationData(response.body.data);
        return { success: true, data: response.body.data };
      } else {
        return {
          success: false,
          message: response.body.message || "Failed to add proof documents",
        };
      }
    } catch (error) {
      this.setVerificationLoader(false);
      return { success: false, message: "Network error occurred" };
    }
  }

  // Add global notes
  async addGlobalNote(verificationId, note, addedBy) {
    this.setVerificationLoader(true);
    try {
      const body = {
        note,
        addedBy,
      };

      const response = await addGlobalNoteApi(verificationId, body);

      this.setVerificationLoader(false);
      if (response.status === 200) {
        this.setVerificationData(response.body.data);
        return { success: true, data: response.body.data };
      } else {
        return {
          success: false,
          message: response.body.message || "Failed to add global note",
        };
      }
    } catch (error) {
      this.setVerificationLoader(false);
      return { success: false, message: "Network error occurred" };
    }
  }

  // Get verification summary
  async getVerificationSummary(verificationId) {
    this.setVerificationLoader(true);
    try {
      const response = await getVerificationSummaryApi(verificationId);
      this.setVerificationLoader(false);

      if (response.status === 200) {
        return { success: true, data: response.body.data };
      } else {
        return {
          success: false,
          message:
            response.body.message || "Failed to get verification summary",
        };
      }
    } catch (error) {
      this.setVerificationLoader(false);
      return { success: false, message: "Network error occurred" };
    }
  }
}
export default RecuiterStore;
